function showalert(title, message, onclick, duration = 10000) {
    let $placeholder = $('#alert-placeholder');
    if ($('#alert-placeholder').length < 1) {
        $placeholder = $('<div>', {
            id: 'alert-placeholder'
        });
        $('body').append($placeholder);
    }
    $('#alert-placeholder').append('<div id="alertdiv" class="alert alert-info"><a class="close" data-dismiss="alert" >×</a><div id="alert-content"><h4>' + title + '</h4><p>' + message + '</p></div></div>');
    if (onclick) {
        $("#alert-content").click(function () {
            onclick();
        });
    }
    setTimeout(function () {
        $("#alertdiv").remove();
    }, duration);
}

function handleFileDownload(url, accessToken, fileName) {
    let headers = {};
    if(accessToken != null && typeof accessToken !== undefined && accessToken !== "") {
        headers = {...headers, ...{
                Authorization:
                    'Bearer ' + accessToken
            }};
    }
    fetch(url, { headers })
        .then((response) => response.blob())
        .then((blob) => {
            // Create  blob  URL
            const blobUrl = window.URL.createObjectURL(blob);
            // Create a temporary anchor el
            const anchorEl = document.createElement('a');
            anchorEl.href = blobUrl;
            anchorEl.download = fileName; // Set any filename and extension            
            anchorEl.style.display = 'none';

            // Append the a tag to the DOM and click it to trigger download
            document.body.appendChild(anchorEl);
            anchorEl.click();

            // Clean up
            document.body.removeChild(anchorEl);
            window.URL.revokeObjectURL(blobUrl);
        })
        .catch((error) => {
            console.error('Error downloading file:', error);
        });
}

function expandCurrentMenuPage() {
    var parents = $(".currentPage").parentsUntil("ul.sidebar-menu").addClass("menu-open");
    $(".currentPage").parentsUntil().css("display", "block");
    //var height = $(".sidebar-menu").height();
    //$(".content-wrapper").css('min-height', height);
}

/**
 * rippleAnimateOnClick
 * This function handles the "ripple animation" on click
 * Inspired by Material Design guidelines
 * @param {Object} el - javascript dom object or selector
 * @param {Object} event - click event
 */
function rippleAnimateOnClick(el, event) {
    //to limit the animation use a container like this <del style='overflow: hidden; position: relative;'></del>

    var parent, ink, d, x, y, e;
    e = event;
    parent = $(el).parent();
    //create .ink element if it doesn't exist
    if (parent.find(".sp-animation-ripple-ink").length == 0) {
        parent.prepend("<span class='sp-animation-ripple-ink'></span>");
    }
    ink = parent.find(".sp-animation-ripple-ink");
    //in case of quick double clicks stop the previous animation
    ink.removeClass("animate");

    //set size of .ink
    if (!ink.height() && !ink.width()) {
        //use parent's width or height whichever is larger for the diameter to make a circle which can cover the entire element.
        d = Math.max(parent.outerWidth(), parent.outerHeight());
        ink.css({height: d, width: d});
    }

    //get click coordinates
    //logic = click coordinates relative to page - parent's position relative to page - half of self height/width to make it controllable from the center;
    x = e.pageX - parent.offset().left - ink.width() / 2;
    y = e.pageY - parent.offset().top - ink.height() / 2;

    //set the position and add class .animate
    ink.css({top: y + 'px', left: x + 'px'}).addClass("animate");
    ink.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (e) {
        ink.removeClass("animate");

    });
}

/**
 *
 */
String.prototype.toSafeID = function () {
    return encodeURIComponent(
        this.toLowerCase()
    ).replace(/^[^a-z]+|[^\w:.-]+/gi, "");
};
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.toCamelCase = function () {
    return this
        .replace(/\s(.)/g, function ($1) {
            return $1.toUpperCase();
        })
        .replace(/\s/g, '')
        .replace(/^(.)/, function ($1) {
            return $1.toLowerCase();
        });
}

/**
 * CanvasRenderingContext2D.prototype.roundRect
 * example: ctx.roundRect(0, 0, 500, 500, 50).fill(); --> draws a 500px square in x=0 y=0 with 50px corner radius.
 * source: https://stackoverflow.com/a/7838871
 * @param {Number} x - rectangle top x
 * @param {Number} y - rectangle top y
 * @param {Number} w - rectangle width
 * @param {Number} h - rectangle height
 * @param {Number} r - corner radius
 */
CanvasRenderingContext2D.prototype.roundRect = function (x, y, w, h, r) {
    if (w < 2 * r) r = w / 2;
    if (h < 2 * r) r = h / 2;
    this.beginPath();
    this.moveTo(x + r, y);
    this.arcTo(x + w, y, x + w, y + h, r);
    this.arcTo(x + w, y + h, x, y + h, r);
    this.arcTo(x, y + h, x, y, r);
    this.arcTo(x, y, x + w, y, r);
    this.closePath();
    return this;
};

/**
 * mapToRange
 * This function maps a Number value to a new range
 * @param {Number} num - number that needs to be mapped
 * @param {Number} in_min - minimum value that {num} may assume
 * @param {Number} in_max - maximum value that {num} may assume
 * @param {Number} out_min - minimum value of the new range
 * @param {Number} out_max - maximum value of the new range
 */
const mapToRange = (num, in_min, in_max, out_min, out_max) => {
    return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
};

function setUserSidebarPreferenceCollapsed() {
    createCookie("userMenuCollapsed", true, 10);
}

function setUserSidebarPreferenceExpanded() {
    eraseCookie("userMenuCollapsed");
}

function initUserSidebarPreferences() {
    Space1.UI.sidebar.open();
    Space1.UI.sidebar.activeHamburgerState();
    
    // if (readCookie("userMenuCollapsed")) { // temporary disabled
    //     Space1.UI.sidebar.close();
    //     Space1.UI.sidebar.inactiveHamburgerState();
    // }
}

function manageAbortOnClick(e) {

    e.stopImmediatePropagation();
    e.preventDefault();

    var href = $(this).attr("href");

    $.ajax({
        type: 'GET',
        url: href,
        success: function (response) {
            if (Space1.Util.isJson(response)) {
                var returnObj = response;
                console.log(returnObj);

                document.location.reload();

            }
            ;
        },
        error: function () {

        }
    });
}

function createCookie(name, value, days) {
    let expires;
    days = (days) ? days : 1;
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    let nameEQ = encodeURIComponent(name) + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

Space1.Util.Cookies = {
    create: createCookie,
    read: readCookie,
    delete: eraseCookie
};

Space1.Util.SessionStorage = {
    create: (key, value)=>{
        sessionStorage.setItem(key, value);
    },
    read: (key)=>{
        return sessionStorage.getItem(key);
    },
    delete: (key)=>{
        sessionStorage.removeItem(key);
    }
};

Space1.Util.device = new MobileDetect(window.navigator.userAgent);


Space1.Util.deviceDetect = new DeviceDetect(window.navigator.userAgent);

function DeviceDetect(userAgent) {

    let self = this;

    let _userAgent = userAgent;

    let _mobileDetect = new MobileDetect(userAgent);

    this.isMobile = function () {
        try {

            return _mobileDetect.mobile() || self.isIpad();


            //var ua = _userAgent.toLowerCase();

            //return [
            //     'iPad Simulator',
            //     'iPhone Simulator',
            //     'iPod Simulator',
            //     'iPad',
            //     'iPhone',
            //     'iPod'
            // ].includes(navigator.platform)
            //     // iPad on iOS 13 detection
            //     || (ua.includes("mac") && "ontouchend" in document) || ua.indexOf("android") > -1 || ua.indexOf("mobile") > -1 ;

        } catch (error) {
            console.error(error);
        }
    },

        this.isIphone = function () {

            return _mobileDetect.is('iPhone');
        },

        this.isIpad = function () {
            if (_userAgent.indexOf('iPad') > -1) {
                return true;
            }

            if (_userAgent.indexOf('Mac') > -1) {
                if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2)
                    return true;
            }

            if (_userAgent.indexOf('Macintosh') > -1) {
                try {
                    document.createEvent("TouchEvent");
                    return true;
                } catch (e) {
                }
            }

            return false;
        },

        this.isSafari = function () {

            try {

                return _mobileDetect.userAgent() === 'Safari';
            } catch (error) {
                console.error(error);
            }

        },

        this.isChrome = function () {

            try {
                return _mobileDetect.userAgent() === 'Chrome';
            } catch (error) {
                console.error(error);
            }
        },
        this.isFirefox = function () {

            try {
                return _mobileDetect.userAgent() === 'Firefox';
            } catch (error) {
                console.error(error);
            }
        }

    this.isAndroid = function () {

        try {
            return _mobileDetect.is('AndroidOS');
        } catch (error) {
            console.error(error);
        }
    }



}

Space1.Util.getBrowser = function () {
    const userAgent = navigator.userAgent;
    let browser = "unkown";
    // Detect browser name
    browser = (/ucbrowser/i).test(userAgent) ? 'UCBrowser' : browser;
    browser = (/edg/i).test(userAgent) ? 'Edge' : browser;
    browser = (/googlebot/i).test(userAgent) ? 'GoogleBot' : browser;
    browser = (/chromium/i).test(userAgent) ? 'Chromium' : browser;
    browser = (/firefox|fxios/i).test(userAgent) && !(/seamonkey/i).test(userAgent) ? 'Firefox' : browser;
    browser = (/; msie|trident/i).test(userAgent) && !(/ucbrowser/i).test(userAgent) ? 'IE' : browser;
    browser = (/chrome|crios/i).test(userAgent) && !(/opr|opera|chromium|edg|ucbrowser|googlebot/i).test(userAgent) ? 'Chrome' : browser;
    browser = (/safari/i).test(userAgent) && !(/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i).test(userAgent) ? 'Safari' : browser;
    browser = (/opr|opera/i).test(userAgent) ? 'Opera' : browser;
    return browser;
}


Space1.Util.mimeTypeFromFilename = function (filename) {
    let nameParts = filename.split('.');
    let extension = nameParts.pop().toLowerCase();
    let mimeTypes = [
        {'pdf': 'application/pdf'},
        {'jpg': 'image/jpeg'},
        {'jpeg': 'image/jpeg'},
        {'png': 'image/png'},
        {'mp4': 'video/mp4'},
        {'m4v': 'video/mp4'},
        {'mp3': 'audio/mpeg'},
        {'wav': 'audio/wav'},
    ];

    let mimeType = mimeTypes.find((type) => {
        return type[extension] != undefined
    });
    if (mimeType != undefined) {
        return mimeType[extension];
    } else {
        return 'application/octet-stream';
    }
};

Space1.Util.fileTypeFromPath = function (path) {
    path = path.toLowerCase();
    if (path.includes(".png")
        || path.includes(".jpg")
        || path.includes(".jpeg")
        || path.includes(".gif")) {
        return 'Image';
    } else if (path.includes(".webm")
        || path.includes(".avi")
        || path.includes(".mp4")) {
        return 'Video';
    } else if (path.includes(".pdf")) {
        return 'Document';
    } else {
        console.error("Unable to guess file type from path");
    }
}

Space1.Util.removeParagraphs = function (string) {
    let newString = "";
    newString = string.replace('<p>', '');
    return newString.replace('</p>', '');
};

class LoadAnimation {
    /**
     * LoadAnimation - builds a loader; loaders could bind to global ajax events or be manually triggered.
     * @param {String} selector - valid css selector of container where to append animation
     * @param {String} type - "load-1" | "load-2" | "load-3" | "progressbar" | "progressicon" | "error" (optional)
     */
    constructor(selector, type = "load-2") {
        this.vars = {};
        this.vars.selector = selector || '';
        this.vars.$container = $(this.vars.selector);

        if (!this.vars.$container.length) {
            console.warn("LoadAnimation: Container selector not found: " + this.vars.selector);
        }

        try {
            this.vars.$container[0].loadAnimation = this;
        } catch (error) {
            console.warn("Unable to set element property.");
        }

        this.vars.$container.attr('data-loadanimation', '');

        this.vars.counter = 0;
        this.vars.previousType = type;
        this.vars.type = type;
        this.vars.isAjaxListening = false;
        this.vars.isBeforeUnloadListening = false;
        this.vars.tooltip = null;
        this.vars.$typeContainer = $("<div>");
        this.vars.$progressBar = $("<div>");
        this.vars.$progressIconGradientContainer = $("<div>");
        this.vars.$progressIconGradient = $("<div>");
        this.vars.$progressIcon = $("<i>", {class: "fa fa-cloud-upload-alt"});
        this.vars.$errorIcon = "⚠";

        this._buildInnerStructure();

        // manually bind context
        this._buildInnerStructure = this._buildInnerStructure.bind(this);
        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.disable = this.disable.bind(this);
        this.enableGlobalAjaxListener = this.enableGlobalAjaxListener.bind(this);
        this.disableGlobalAjaxListener = this.disableGlobalAjaxListener.bind(this);
        this.enablePageReloadListener = this.enablePageReloadListener.bind(this);
        this.disablePageReloadListener = this.disablePageReloadListener.bind(this);
        this.destroy = this.destroy.bind(this);
    }

    /**
     * _buildInnerStructure - builds the DOM structure of the loader (private method)
     * @param {LoadAnimation} context - (optional)
     */
    _buildInnerStructure(context = this) {
        // currently able to build only load-1; load-2 and load-3 and progressbar
        // check: https://codepen.io/Manoz/pen/pydxK
        // todo: implement other spinners

        context.vars.$typeContainer.empty();
        context.vars.$typeContainer[0].classList = context.vars.type;
        switch (context.vars.type) {
            case "progressbar":
                context.vars.counter = 0;
                //context.setProgress(0);
                context.vars.$progressBar.css("width", 0);
                context.vars.$typeContainer.append(context.vars.$progressBar);
                break;
            case "progressicon":
                context.vars.counter = 0;
                context.vars.$container.css("position", "relative");
                context.vars.$typeContainer.append(context.vars.$progressIconGradientContainer);
                context.vars.$progressIconGradientContainer.append(context.vars.$progressIconGradient);
                context.vars.$typeContainer.append(context.vars.$progressIcon);
                break;
            case "error":
                context.vars.counter = 0;
                context.vars.$typeContainer.append(context.vars.$errorIcon);

            default:
                context.vars.$typeContainer.append("<div class='line'></div> <div class='line'></div> <div class='line'></div>");
        }

        context.vars.$container.append(context.vars.$typeContainer);

        context.stop();

        return context;
    }

    /**
     * start - starts the loader animation
     * @param {Event} event - (optional) catches events from listeners, to adapt return behavior
     * @param {String} reason - (optional) if specified, is displayed in a tooltip when hovering the loader
     * @param {LoadAnimation} context - (optional)
     */
    start(event = null, reason = "", context = this) {
        // prevent events being passed as parameters
        context = context instanceof LoadAnimation ? context : this;
        reason = typeof (reason) === "string" ? reason : "";

        try {
            context.vars.counter++;
            context.vars.$container.trigger('start');

            if (context.vars.type !== "progressbar") {
                context.vars.$container.stop().fadeIn();

                if (reason.length) {
                    context.setTooltip(reason, context);
                }

                if (typeof (event) === "undefined" || event === null || event.type !== "beforeunload") {
                    // return instance for method chaining only when the caller isn't an unload event handler
                    return context;
                }
            } else {
                //console.warn("LoadAnimation of type progress-bar can't be started.");
            }

        } catch (error) {
            console.warn(`Unable to start LoadAnimation: ${error}`);
        }

    }

    /**
     * stop - stops the loader animation
     * @param {Event} event - (optional) catches events from listeners, to adapt return behavior
     * @param {Boolean} forced - (optional) if specified, the loader will clear it's queue and stop immediately
     * @param {LoadAnimation} context - (optional)
     */
    stop(event = null, forced = false, context = this) {
        // prevent events being passed as parameters
        context = context instanceof LoadAnimation ? context : this;

        try {
            context.vars.$container.trigger('stop');

            if (context.vars.type !== "progressbar" && context.vars.type !== "progressicon") {
                if (forced) {
                    context.vars.counter = 0;
                } else {
                    context.vars.counter--;
                    if (context.vars.counter < 0) {
                        context.vars.counter = 0;
                    }
                }
            }

            if (context.vars.type !== "progressbar" && context.vars.type !== "progressicon") {

                if (context.vars.counter < 1) {
                    context.vars.$container.stop().fadeOut();
                    context.destroyTooltip(context);
                }
                if (typeof (event) === "undefined" || event === null || event.type !== "beforeunload") {
                    // return instance for method chaining only when the caller isn't an unload event handler
                    return context;
                }
            }
        } catch (error) {
            console.warn(`Unable to stop LoadAnimation: ${error}`);
        }

    }

    /**
     * setTooltip - sets the tooltip content
     * @param {String} content - the content of the tooltip
     * @param {LoadAnimation} context - (optional)
     */
    setTooltip(content, context = this) {
        try {
            if (typeof (context.vars.tooltip) === "undefined" || context.vars.tooltip === null) {
                context.vars.tooltip = tippy(context.vars.$typeContainer[0], {
                    content: content,
                    theme: 'light'
                });
            } else {
                context.vars.tooltip.setContent(content);
                context.vars.tooltip.show();
            }
        } catch (error) {
            console.warn(`Unable to setTooltip of LoadAnimation: ${error}`);
        }

        return context;
    }

    /**
     * destroyTooltip - destroy the tooltip instance
     * @param {LoadAnimation} context - (optional)
     */
    destroyTooltip(context = this) {
        try {
            if (typeof (context.vars.tooltip) !== "undefined" && context.vars.tooltip !== null && isFunction(context.vars.tooltip.destroy)) {
                context.vars.tooltip.hide();
                context.vars.tooltip.destroy();
                context.vars.tooltip = null;
            }
        } catch (error) {
            console.warn(`Unable to destroyTooltip of LoadAnimation: ${error}`);
        }

        return context;
    }

    /**
     * setProgress - changes the loader type to a Progress Bar
     * @param {Number} value - range: 0-100 is the displayed progress
     * @param {String} reason - (optional) if specified, is displayed in a tooltip when hovering the loader
     * @param {String} type - (optional) progressbar | progressicon
     * @param {LoadAnimation} context - (optional)
     */
    setProgress(value, reason = "", type = "progressbar", context = this) {

        try {
            context.setType(type, context);
            if (Space1.Util.isNumber(value)) {
                if (!context.vars.$container.is(":visible")) {
                    context.vars.$container.stop().fadeIn();
                }

                context.vars.$container.trigger('progress');

                if (reason.length) {
                    context.setTooltip(reason, context);
                }

                switch (context.vars.type) {
                    case "progressbar":

                        context.vars.$progressBar.stop(true, true).animate({
                            width: `${value}%`
                        }, 200, "easeInQuad", () => {
                            if (value >= 100) {
                                context.vars.$container.stop().fadeOut();
                                context.destroyTooltip(context);
                                context.setType(context.vars.previousType);
                            }
                        });

                        break;
                    case "progressicon":
                        context.vars.$progressIconGradient.stop(true, true).animate({
                            height: `${value}%`
                        }, 200, "easeInQuad", () => {
                            if (value >= 100) {

                                context.destroyTooltip(context);
                                context.setType(context.vars.previousType);
                            }
                        });
                        break;
                }


            } else {
                console.warn("setProgress(value): value NaN");
            }
        } catch (error) {
            console.warn(`Unable to setProgress of LoadAnimation: ${error}`);
        }

        return context;
    }

    /**
     * disable - disables the loader and hides it
     * @param {LoadAnimation} context - (optional)
     */
    disable(context = this) {
        try {
            context.vars.counter = 0;
            context.vars.$container.stop().fadeOut();
        } catch (error) {
            console.warn(`Unable to disable LoadAnimation: ${error}`);
        }

        return context;
    }

    /**
     * setType - changes the loader type to the one specified
     * @param {String} type -  "load-1" | "load-2" | "load-3" | "progressbar" (optional)
     * @param {LoadAnimation} context - (optional)
     */
    setType(type, context = this) {
        try {
            if (type !== context.vars.type) {
                context.vars.previousType = context.vars.type;
                context.vars.type = type || context.vars.type;
                context.vars.$typeContainer[0].classList = type;
                context.vars.$container.trigger('stop');
                context._buildInnerStructure(context);
            }
        } catch (error) {
            console.warn(`Unable to setType of LoadAnimation: ${error}`);
        }

        return context;
    }

    /**
     * enableGlobalAjaxListener - the loader autostarts/stops when ajaxSend and ajaxComplete are dispatched
     * @param {LoadAnimation} context - (optional)
     */
    enableGlobalAjaxListener(context = this) {
        try {
            context.vars.isAjaxListening = true;
            $(document)
                .bind("ajaxSend", context.start)
                .bind("ajaxComplete", context.stop);
        } catch (error) {
            console.warn(`Unable to enableGlobalAjaxListener of LoadAnimation: ${error}`);
        }

        return context;
    }

    /**
     * disableGlobalAjaxListener - disables the loader autostart/stop on ajax events
     * @param {LoadAnimation} context - (optional)
     */
    disableGlobalAjaxListener(context = this) {
        try {
            context.vars.isAjaxListening = false;
            $(document)
                .unbind("ajaxSend", context.start)
                .unbind("ajaxComplete", context.stop);
        } catch (error) {
            console.warn(`Unable to disableGlobalAjaxListener of LoadAnimation: ${error}`);
        }

        return context;
    }

    /**
     * enablePageReloadListener - the loader autostarts/stops when the document is unloading
     * @param {LoadAnimation} context - (optional)
     */
    enablePageReloadListener(context = this) {
        try {
            context.vars.isBeforeUnloadListening = true;
            $(window).on('beforeunload', context.start);
        } catch (error) {
            console.warn(`Unable to enablePageReloadListener of LoadAnimation: ${error}`);
        }

        return context;
    }

    /**
     * enablePageReloadListener - disabled the loader autostart/stop when the document is unloading
     * @param {LoadAnimation} context - (optional)
     */
    disablePageReloadListener(context = this) {
        try {
            context.vars.isBeforeUnloadListening = false;
            $(window).off('beforeunload', context.start);
        } catch (error) {
            console.warn(`Unable to disablePageReloadListener of LoadAnimation: ${error}`);
        }

        return context;
    }

    /**
     * destroy - destroy the loader instance and DOM associated elements
     * @param {LoadAnimation} context - (optional)
     */
    destroy(context = this) {
        try {
            context.stop(true);
            context.disableGlobalAjaxListener();
            context.disablePageReloadListener();
            context.destroyTooltip();
            try {
                delete context.vars.$container[0].loadAnimation;
            } catch (error) {
                console.warn("Unable to unset LoadAnimation DOM element property.");
            }
            context.vars.$container.remove();
            context.vars = {};
        } catch (error) {
            console.warn(`Unable to destroy instance of LoadAnimation: ${error}`);
        }

        return null;
    }
}

const globalLoadAnimation = new LoadAnimation("#global-loader");
globalLoadAnimation.start();


function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
}

function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

class RectScrollListener {
    /**
     * RectScrollListener returns live updates on an element position (during scroll, drag etc.)
     * @param {string} id - valid ID of dom element to be watched
     * @param {Number} range - limit range of scroll from top in px
     * @param {Boolean} normalized - if true returns normalized valus, otherwise complete Rect object position
     */
    constructor(id, range = 0, normalized = false) {
        var self = this;
        this._id = id;
        this._el = document.getElementById(this._id);
        this._$el = $(this._el);
        this._callback = () => {
        };
        try {
            this.rect = this._el.getBoundingClientRect();
        } catch (error) {
            console.warn("RectScrollListener: Element not defined.");
        }

        this.initial = Object.freeze({rect: self.rect});

        this._$window = $(window);
        this._scrollTop = this._$window.scrollTop();
        this._height = this._$el.outerHeight();
        this._offset = this._height / 2;
        this._range = range;
        this._returnNormalized = normalized;
        this._normalizedValue = 1 - (this._scrollTop - this._offset + this._range) / this._range;

        // manually bind context
        this.setCallback = this.setCallback.bind(this);
        this.listen = this.listen.bind(this);
        this.mute = this.mute.bind(this);
        this._onScroll = this._onScroll.bind(this);
        this.getNormalizedValue = this.getNormalizedValue.bind(this);

    }

    setCallback(callback) {
        var context = this;
        if (isFunction(callback)) {
            this._callback = callback.bind(context);
        } else {
            console.warn("Callback is not a function.");
            context._callback = (rect) => {
            };
        }
    }

    listen(callback) {
        var context = this;

        if (isFunction(callback)) {
            context._callback = callback.bind(context);
        } else {
            console.warn("Callback is not a function.");
            context._callback = (rect) => {
            };
        }

        context._$window.on('scroll', context._onScroll);
    }

    mute() {
        var context = this;
        context._$window.off('scroll', context._onScroll);
    }

    _onScroll(event) {
        var context = this;
        context._scrollTop = context._$window.scrollTop();
        context._normalizedValue = 1 - (context._scrollTop - context._offset + context._range) / context._range;

        context.rect = context._el.getBoundingClientRect();
        if (context._returnNormalized) {
            context._callback(context.getNormalizedValue());
        } else {
            context._callback(context.rect);
        }
    }

    getNormalizedValue() {
        var context = this;
        if (context._normalizedValue > 1) {
            context._normalizedValue = 1;
        } else if (context._normalizedValue < 0) {
            context._normalizedValue = 0;
        }
        return context._normalizedValue;
    }
}

function moveTitleToTopBar() {
    const $title = $("#page-title");
    const $topBarTitle = $("#page-title-holder");
    var titlePosition = new RectScrollListener("page-title", 10, true);

    $title.css({opacity: titlePosition.getNormalizedValue()});
    $topBarTitle.css({opacity: (1 - titlePosition.getNormalizedValue())});

    titlePosition.listen((scrollFactor) => {
        $title.css({opacity: scrollFactor});
        $topBarTitle.css({opacity: (1 - scrollFactor)});
    });
}

//moveTitleToTopBar(); --> disabled after moving title to topbar

/************ SPACE1 ************/

/**
 * Space1.Util.getUserDisplayName
 * Returns user info for display purpose
 */
Space1.Util.getUserDisplayName = function (user) {
    return `${user.name} ${user.surname}`;
}


Space1.UI.showInfoPopover = function (elem, text, placement = "right", timeout = 3000) {
    elem.popover({
        placement: placement,
        trigger: 'manual',
        container: 'body',
        content: text
    });

    elem.popover('show');
    setTimeout(function () {
        elem.popover('hide');
    }, timeout);
}

/**
 * Space1.Util.isNumber
 * This function returns true if the input is typeof Number
 * @param {Object} n - variable to check
 */
Space1.Util.isNumber = function (n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0)
};

Space1.Util.isGuid = function isGuid(stringToTest) {
    if (stringToTest[0] === "{") {
        stringToTest = stringToTest.substring(1, stringToTest.length - 1);
    }
    var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
    return regexGuid.test(stringToTest);
}

/**
 * Space1.Util.getUserLocale
 * This function returns the user browser locale
 */
Space1.Util.getUserLocale = function () {
    let language;
    if (window.navigator.languages) {
        language = window.navigator.languages[0];
    } else {
        language = window.navigator.userLanguage || window.navigator.language;
    }

    return language;
};

/**
 * Space1.Util.Aggregation -- Aggregation of Base Class and Mixin Classes
 * @copyright Copyright (c) 2015-2018 Ralf S. Engelschall <rse@engelschall.com>
 * @author https://github.com/rse/aggregation
 */

Space1.Util.aggregation = (base, ...mixins) => {

    /*  create aggregation class  */
    let aggregate = class __Aggregate extends base {
        constructor(...args) {
            /*  call base class constructor  */
            super(...args);

            /*  call mixin's initializer  */
            mixins.forEach((mixin) => {
                if (typeof mixin.prototype.initializer === "function")
                    mixin.prototype.initializer.apply(this, args)

            })
        }
    };

    /*  copy properties  */
    let copyProps = (target, source) => {
        Object.getOwnPropertyNames(source)
            .concat(Object.getOwnPropertySymbols(source))
            .forEach((prop) => {
                if (prop.match(/^(?:initializer|constructor|prototype|arguments|caller|name|bind|call|apply|toString|length)$/))
                    return;
                Object.defineProperty(target, prop, Object.getOwnPropertyDescriptor(source, prop))
            })
    };

    /*  copy all properties of all mixins into aggregation class  */
    mixins.forEach((mixin) => {
        copyProps(aggregate.prototype, mixin.prototype);
        copyProps(aggregate, mixin)
    });

    return aggregate
};

/**
 * Space1.Util.tabState
 * This object keeps track of the current tab state (visible or hidden)
 *
 * Listen for Space1.Util.tabState.hidden and Space1.Util.tabState.visible events on document to get current tab state
 */
Space1.Util.tabState = {
    _hidden: null,
    _state: null,
    _visibilityChange: null,
    _isTabVisible: true,
    _listenerActive: false,

    initListener() {
        if (!this._listenerActive) {
            this._listenerActive = true;
            // Adapted slightly from Sam Dutton
            // Set name of hidden property and visibility change event
            // since some browsers only offer vendor-prefixed support
            if (typeof document.hidden !== "undefined") {
                this._hidden = "hidden";
                this._visibilityChange = "visibilitychange";
                this._state = "visibilityState";
            } else if (typeof document.mozHidden !== "undefined") {
                this._hidden = "mozHidden";
                this._visibilityChange = "mozvisibilitychange";
                this._state = "mozVisibilityState";
            } else if (typeof document.msHidden !== "undefined") {
                this._hidden = "msHidden";
                this._visibilityChange = "msvisibilitychange";
                this._state = "msVisibilityState";
            } else if (typeof document.webkitHidden !== "undefined") {
                this._hidden = "webkitHidden";
                this._visibilityChange = "webkitvisibilitychange";
                this._state = "webkitVisibilityState";
            }

            // Add a listener that constantly changes the title
            let self = this;
            document.addEventListener(self._visibilityChange, (ev) => {
                let $event;
                switch (document[self._state]) {
                    case 'visible':
                        self._isTabVisible = true;
                        $event = $.Event('Space1.Util.tabState.visible');
                        break;
                    case 'hidden':
                        self._isTabVisible = false;
                        $event = $.Event('Space1.Util.tabState.hidden');
                        break;
                }
                ;

                $(document).trigger($event);
            }, false);
        }
    },

    get isVisible() {
        if (this._listenerActive == true) {
            return this._isTabVisible;
        } else {
            return new Error("Unable to get Tab state.");
        }
    },

    get isHidden() {
        if (this._listenerActive == true) {
            return !this._isTabVisible;
        } else {
            return new Error("Unable to get Tab state.");
        }
    }
};

/**
 * Space1.Util.formatTimestamp
 * Given a valid UNIX UTC timestamp, returns a formatted locale string with date & time. Ex. "24/12/2019 - 14:30" if user locale is it_IT
 * @param {Number|String} timestamp - UTC timestamp
 */
Space1.Util.formatTimestamp = function (timestamp) {
    try {
        const dateObject = new Date(Number(timestamp) * 1000);
        return `${dateObject.toLocaleDateString()} - ${dateObject.toLocaleTimeString()}`;
    } catch (error) {
        console.warn("Timestamp invalid.", error);
        return timestamp.toString();
    }
};


/**
 * Space1.Util.getMonthName
 * Given a month number, returns a locale name month
 * @param {Number|String} timestamp - UTC timestamp
 */
Space1.Util.getMonthName = function (monthNumber) {
    try {
        const dateObject = new Date(2000, 0, 1);
        dateObject.setMonth(Number(monthNumber) - 1);

        return dateObject.toLocaleString(Space1.Util.getUserLocale(), {month: "long"});
    } catch (error) {
        console.warn("Month number invalid.", error);
        return monthNumber.toString();
    }
};


/**
 * Space1.Util.secondsToHHMMSS
 * Given a valid number of seconds, returns a formatted string -> hh:mm:ss
 * @param {Number|String} seconds
 */
Space1.Util.secondsToHHMMSS = function (seconds) {
    try {
        return new Date(seconds * 1000).toISOString().substr(11, 8);
    } catch (error) {
        console.warn("Seconds invalid.", error);
        return seconds.toString();
    }
};

/**
 * Space1.Util.hhmmssToSeconds
 * Given a valid number of seconds, returns a formatted string -> hh:mm:ss
 * @param {Number|String} seconds
 */
Space1.Util.hhmmssToSeconds = function (hhmmss) {
    const temp = hhmmss.split('.');
    hhmmss = temp[0];

    let msToSec = 0;
    if (temp.length > 1 && temp[1] > 0) {
        const ms = temp[1];
        msToSec = ms / 1000;
    }

    return hhmmss.split(':').reduce((acc, time) => (60 * acc) + +time) + Number(msToSec);
};

/**
 * Space1.Util.formatDatetime
 * Given a C# datetime, returns a formatted locale string with date & time. Ex. "24/12/2019 - 14:30" if user locale is it_IT
 * @param {Number|String} datetime - UTC datetime
 */
Space1.Util.formatDatetime = function (datetime) {
    try {
        var offset = new Date().getTimezoneOffset();
        let dateObject = new Date(Date.parse(datetime));
        dateObject = new Date(dateObject.getTime() - offset * 60000);

        return `${dateObject.toLocaleDateString()} - ${dateObject.toLocaleTimeString()}`;
    } catch (error) {
        console.warn("Datetime invalid.", error);
        return datetime.toString();
    }
};

Space1.Util.formatDatetime.autoFormat = function () {
    $('[data-format-datetime]').each(function (index) {
        $(this).text(Space1.Util.formatDatetime($(this).data('format-datetime')));
    });
};

/**
 * Space1.Util.breakInLines
 * @param {String} sentence - string that needs to be whitespaced and broken in lines
 * @param {Number} maxWidth - max line length
 */
Space1.Util.breakInLines = function (sentence, maxWidth) {
    return sentence.replace(new RegExp(`(?![^\\n]{1,${maxWidth}}$)([^\\n]{1,${maxWidth}})\\s`, 'g'), '$1\n');
};

/**
 * Space1.Util.mapToRange
 * This function maps a Number value to a new range
 * @param {Number} num - number that needs to be mapped
 * @param {Number} in_min - minimum value that {num} may assume
 * @param {Number} in_max - maximum value that {num} may assume
 * @param {Number} out_min - minimum value of the new range
 * @param {Number} out_max - maximum value of the new range
 */
Space1.Util.mapToRange = function (num, in_min, in_max, out_min, out_max) {
    return mapToRange(num, in_min, in_max, out_min, out_max);
}.bind(mapToRange);

/**
 * Space1.Util.newGuid
 * returns and RFC4122 version 4 compliant UUID. Don't use this for crypto purposes.
 * example: e2578f45-82bd-4a64-bf40-f3aa66974547
 */
Space1.Util.newGuid = function () {
    return String(uuidv4());
}.bind(uuidv4);

Space1.Util.newGuid.empty = function () {
    return "00000000-0000-0000-0000-000000000000";
};

/**
 * Space1.UI.deleteItem
 */
Space1.UI.deleteItem = function (itemId, itemName = "") {
    try {
        let $toBeDeleted = $(`[data-ui-guid=${itemId}]`);
        $toBeDeleted.trigger('space1.delete');
        setTimeout(() => {
            $toBeDeleted.fadeOut(() => {
                $toBeDeleted.remove();
            });
            if (itemName != "") {
                Space1.UI.showAlert(`🗑️ ${Space1.Strings.getKey('DeletedItem')}`, itemName);
            }
        }, 250);
    } catch (error) {
        console.log(`Unable to delete from UI: ${itemId}`, error);
    }
};

Space1.UI.initTooltips = function () {
    tippy(".tippy-tip", {
        theme: 'light',
        animateFill: true,
        arrow: false
    });
}

Space1.UI.googleMapsItem = {
    mapOptions: {},
    map: null,
    mapBounds: null,
    mapContainer: null,
    markers: [],
    init(mapContainer, onReady) {
        this.mapContainer = mapContainer;
        this.loadGoogleMapsSDK(() => {
            this.buildGoogleMap(); //context.loadAnimation.stop();
            if (onReady !== undefined) {
                onReady(this);
            }
        });
        return this;
    },

    loadGoogleMapsSDK(onLoadedCallback) {
        if (!(typeof google === 'object' && typeof google.maps === 'object')) {
            const script = document.createElement("script");
            const url = "https://maps.googleapis.com/maps/api/js?key=" + Space1.googleMapsApiKey + "&v=quarterly&libraries=places,geometry";
            script.type = "text/javascript";
            script.defer = true;

            if (script.readyState) {  //IE
                script.onreadystatechange = function () {
                    if (script.readyState == "loaded" ||
                        script.readyState == "complete") {
                        script.onreadystatechange = null;

                        onLoadedCallback();
                    }
                };
            } else {  //Others
                script.onload = function () {
                    onLoadedCallback();
                };
            }

            script.src = url;
            document.getElementsByTagName("head")[0].appendChild(script);
        } else {
            onLoadedCallback();
        }

        return this;
    },

    buildGoogleMap() {
        this.mapOptions = {
            zoom: 17,
            styles: [
                {
                    "featureType": "all",
                    "stylers": [
                        {"saturation": 0},
                        {"hue": "#e7ecf0"}
                    ]
                },
                {
                    "featureType": "road",
                    "stylers": [
                        {"saturation": -70}
                    ]
                },
                {
                    "featureType": "transit",
                    "stylers": [
                        {"visibility": "off"}
                    ]
                },
                {
                    "featureType": "poi",
                    "stylers": [
                        {"visibility": "off"}
                    ]
                },
                {
                    "featureType": "water",
                    "stylers": [
                        {"visibility": "simplified"},
                        {"saturation": -60}
                    ]
                }
            ],
            maxZoom: 20,
            minZoom: 0,
            center: new google.maps.LatLng(46.09932, 13.23022),
            mapTypeId: 'roadmap',
        };

        this.mapOptions.clickableIcons = true;
        this.mapOptions.disableDoubleClickZoom = false;
        this.mapOptions.draggable = true;
        this.mapOptions.keyboardShortcuts = true;
        this.mapOptions.scrollwheel = true;

        const setControlOptions = (key, enabled, position, style, mapTypeIds) => {
            this.mapOptions[key + 'Control'] = enabled;
            this.mapOptions[key + 'ControlOptions'] = {
                position: google.maps.ControlPosition[position],
                style: google.maps.MapTypeControlStyle[style],
                mapTypeIds: mapTypeIds
            };
        };

        setControlOptions('fullscreen', false, 'DEFAULT', '', null);
        setControlOptions('mapType', false, 'DEFAULT', 'DEFAULT', ["roadmap", "satellite", "terrain"]);
        setControlOptions('rotate', true, 'DEFAULT', '', null);
        setControlOptions('scale', true, '', '', null);
        setControlOptions('streetView', true, 'DEFAULT', '', null);
        setControlOptions('zoom', true, 'DEFAULT', '', null);

        this.map = new google.maps.Map(this.mapContainer, this.mapOptions);

        this.mapBounds = new google.maps.LatLngBounds();

        this.markerIconOptions = {
            path: 'M10 13.9c-2.8-0.5-5-2.9-5-5.9 0-3.3 2.7-6 6-6 3.3 0 6 2.7 6 6 0 3-2.2 5.4-5 5.9l0 8.1 -2 0 0-8.1',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#b90041',
            strokeOpacity: 0
        };

        // restore the zoom level after the map is done scaling
        let self = this;
        const listener = google.maps.event.addListener(this.map, "idle", function () {
            self.map.fitBounds(self.mapBounds);
            google.maps.event.removeListener(listener);
        });

        return this;
    },

    addMarker(latitude, longitude, description = "") {
        if (typeof google === 'object' && typeof google.maps === 'object') {
            if (latitude !== undefined && longitude !== undefined) {

                const newInfoWindow = new google.maps.InfoWindow();

                const newMarker = new google.maps.Marker({
                    position: new google.maps.LatLng(latitude, longitude),
                    map: this.map,
                    icon: this.markerIconOptions
                });

                google.maps.event.addListener(newMarker, 'click', (function (marker, description) {
                    return function () {
                        newInfoWindow.setContent(description);
                        newInfoWindow.open(this.map, marker);
                    };
                })(newMarker, description));

                this.markers.push(newMarker);

                //extend the bounds to include each marker's position
                this.mapBounds.extend(newMarker.position);
                //now fit the map to the newly inclusive bounds
                this.map.fitBounds(this.mapBounds);
            }
        }
        return this;
    }
};

/**
 * Space1.UI.nightMode
 */
Space1.UI.nightModeSwitch = function () {
    console.log("Wo! You discover new things!");

    if ($('#nightmode').length == 0) {

        createCookie("sp-nightmode", true, 10);

        $('body').prepend(
            `<style id="nightmode">
                :root {
                    background-color: #fefefe;
                    filter: invert(100%);
                }
                
                img, video, canvas:not(.chartjs-render-monitor), .plyr, #global-loader, .sidebar-entry--main > a {
                    filter: invert(100%);
                }
            </style>`
        );


    } else {
        eraseCookie("sp-nightmode");
        $('#nightmode').remove();
    }
};

/**
 * Space1.UI.showAlert
 * This procedure builds a toast notification
 * @param {String} title - alert title
 * @param {String} message - alert content
 * @param {Function} onclick - callback
 */
Space1.UI.showAlert = function (title, message, onclick) {
    showalert(title, message, onclick)
}.bind(showalert);

/**
 * Space1.UI.Colors
 * This object contains application colors
 */
Space1.UI.Colors = {
    getColorAsHex(cssvarname) {
        let rgbColor = this.getCssVar(cssvarname);
        return this.rgbToHex(rgbColor[0], rgbColor[1], rgbColor[2]);
    },
    getColorAsRgb(cssvarname) {
        let rgbColor = this.getCssVar(cssvarname);
        ;
        return `rgb(${rgbColor[0]}, ${rgbColor[1]}, ${rgbColor[2]})`;
    },
    getColorAsPrefixedHex(cssvarname) {
        let rgbColor = this.getCssVar(cssvarname);
        ;
        return `0x${(this.rgbToHex(rgbColor[0], rgbColor[1], rgbColor[2])).replace('#', '')}`;
    },
    getCssVar(cssvarname) {
        let rgbarray = getComputedStyle(document.body)
            .getPropertyValue(cssvarname).replace(/\s/g, '').split(',');
        rgbarray = rgbarray.map((val) => {
            return parseInt(val)
        });
        return rgbarray;
    },
    /**
     * Given a string, generates procedural color
     * @param string
     * @returns {*}
     */
    generateFromString(str) {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        let colour = '#';
        for (let i = 0; i < 3; i++) {
            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }
        return colour;
    },
    hexToRgb(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    },
    componentToHex(c) {
        let number = parseInt(c);
        let hex = Number(number).toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    },
    rgbToHex(r, g, b) {
        let hex = "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
        return hex;
    },
    setGeneratedColors() {
        let self = this;
        $("[data-js-color-seed]").each(function () {
            let colorSeed = $(this).data('js-color-seed');
            let color = self.generateFromString(String(colorSeed));
            $(this).css('color', color);
        });
    },
    setGeneratedBackgroundColors() {
        let self = this;
        $("[data-js-bgcolor-seed]").each(function () {
            let colorSeed = $(this).data('js-bgcolor-seed');
            let color = self.generateFromString(String(colorSeed));
            $(this).css('background-color', color);
        });
    }
};

/**
 * Space1.UI.sidebar
 * This object handles the sidebar interactions
 */
Space1.UI.sidebar = {
    open: function () {
        if ($("body").hasClass("sidebar-collapse")) {
            $('.main-sidebar').css('transition', 'none');
            $('[data-toggle="push-menu"]').pushMenu('toggle');
        }
    },
    close: function () {
        if (!$("body").hasClass("sidebar-collapse")) {
            $('.main-sidebar').css('transition', 'none');
            $('[data-toggle="push-menu"]').pushMenu('toggle');
        }
    },
    initHamburger: function () {

    },
    activeHamburgerState: function () {
        $("#sidebar-hamburger").addClass('is-active');
    },
    inactiveHamburgerState: function () {
        $("#sidebar-hamburger").removeClass('is-active');
    },

};

/**
 * Space1.UI.fullscreen
 * This object handles fullscreen interactions
 */
Space1.UI.fullscreen = {
    isFullscreen: false,
    _callbacksOnFullscreen: [],
    _callbacksOnFullscreenExit: [],

    // lock scroll position, but retain settings for later
    _lockScroll: function () {
        let $html = $('html');
        let scrollPosition = [
            self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
            self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        ];
        $html.data('scroll-position', scrollPosition);
        $html.data('previous-overflow', $html.css('overflow'));
        $html.css('overflow', 'hidden');
        window.scrollTo(scrollPosition[0], scrollPosition[1]);
        if (Space1.Env.is('DEV') || Space1.Env.is('LOCAL')) {
            console.log('Scroll locked.');
        }
    },

    _unlockScroll: function () {
        let $html = $('html');
        let scrollPosition = $html.data('scroll-position');
        $html.css('overflow', $html.data('previous-overflow'));
        window.scrollTo(scrollPosition[0], scrollPosition[1]);
        if (Space1.Env.is('DEV') || Space1.Env.is('LOCAL')) {
            console.log('Scroll unlocked.');
        }
    },

    _onFullscreen: function () {
        if (!this.isFullscreen) {
            if (Space1.Env.is('DEV') || Space1.Env.is('LOCAL')) {
                console.log('Entering fullscreen.');
            }

            this._lockScroll();
            this.isFullscreen = true;
            $('body').addClass('js-fullscreen');
            for (const callback of this._callbacksOnFullscreen) {
                callback();
            }
        }
    },

    _onFullscreenExit: function () {
        if (this.isFullscreen) {
            if (Space1.Env.is('DEV') || Space1.Env.is('LOCAL')) {
                console.log('Exiting fullscreen.');
            }

            this._unlockScroll();
            this.isFullscreen = false;
            $('body').removeClass('js-fullscreen');
            for (const callback of this._callbacksOnFullscreenExit) {
                callback();
            }
        }
    },

    registerCallbackOnEnter: function (callback) {
        this._callbacksOnFullscreen.push(callback);
    },

    registerCallbackOnExit: function (callback) {
        this._callbacksOnFullscreenExit.push(callback);
    },

    /*
     * Toggle between fullscreen modes
     * Returns true if is entering fullscreen
     **/
    toggle: function () {
        if ((document.fullScreenElement && document.fullScreenElement !== null) ||
            (!document.mozFullScreen && !document.webkitIsFullScreen)) {
            if (document.documentElement.requestFullScreen) {
                document.documentElement.requestFullScreen();
                this._onFullscreen();
                return true;

            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
                this._onFullscreen();
                return true;

            } else if (document.documentElement.webkitRequestFullScreen) {
                document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                this._onFullscreen();
                return true;
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
                this._onFullscreenExit();
                return false;

            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
                this._onFullscreenExit();
                return false;

            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
                this._onFullscreenExit();
                return false;

            }
        }
    },

    eventHandler: function (e) {
        console.log("Detected fullscreen change.");
        if ((document.fullScreenElement && document.fullScreenElement !== null) ||
            (!document.mozFullScreen && !document.webkitIsFullScreen)) {
            this._onFullscreenExit();
        } else {
            this._onFullscreen();
        }
        return;
    },

    init: function () {
        if (document.addEventListener) {
            let self = this;
            document.addEventListener('webkitfullscreenchange', () => {
                self.eventHandler();
            }, false);
            document.addEventListener('mozfullscreenchange', () => {
                self.eventHandler();
            }, false);
            document.addEventListener('fullscreenchange', () => {
                self.eventHandler();
            }, false);
            document.addEventListener('MSFullscreenChange', () => {
                self.eventHandler();
            }, false);
        }
    }
};

/**
 * Space1.UI.ripple
 * This function handles the "ripple animation" on click
 * Inspired by Material Design guidelines
 * @param {Object} el - javascript dom object or selector
 * @param {Object} event - click event
 */
Space1.UI.ripple = function (el, event) {
    return rippleAnimateOnClick(el, event);
}.bind(rippleAnimateOnClick);


/**
 * Space1.UI.LoadAnimation - builds a loader; loaders could bind to global ajax events or be manually triggered.
 * @param {String} selector - valid css selector of container where to append animation
 * @param {String} type - "load-1" | "load-2" | "load-3" | "progressbar" (optional)
 */
Space1.UI.LoadAnimation = LoadAnimation;
Space1.UI.globalLoadAnimation = globalLoadAnimation;

Object.defineProperty(Space1.UI, 'globalModalLoadAnimation', {
    get: function () {
        const modalId = Space1.UI.Modal.getForegroundModalId();

        if (modalId) {
            let $modal = $(`#${modalId}`);
            let $loadAnimationContainer = $modal.find(`#modalLoader-${modalId}`);
            if ($loadAnimationContainer.length > 0) {
                return $loadAnimationContainer[0].loadAnimation;
            }

            $modal.find(".modal-dialog").append($("<div>", {id: `modalLoader-${modalId}`, class: "overlay-loader"}));
            return new LoadAnimation(`#modalLoader-${modalId}`);
        }
    },
    set: function (loadAnim) {
        console.warn("Manually set load animation is deprecated");
    }
});

/**
 * Space1.Util.RequestHandler - handles ajax requests with a simple queue
 */
Space1.Util.RequestHandler = class {

    constructor() {

        this.queue = {
            requests: [],
            isRunning: false,
            averageSpeed: 0,
            doneRequestsCount: 0,
            executionTimeSum: 0
        };

        this.newRequest = this.newRequest.bind(this);
        this.register = this.register.bind(this);
        this._run = this._run.bind(this);
        this.pause = this.pause.bind(this);
        this._handle = this._handle.bind(this);
        this._requestTimeout = this._requestTimeout.bind(this);
        this.done = this.done.bind(this);

    }

    newRequest() {
        return {
            execute: () => {
            },
            id: Space1.Util.newGuid(),
            name: null,
            requestedAt: Date.now(),
            startedAt: null,
            completedAt: null,
            timeNeeded: null,
            completed: false,
            timedOut: false,
            self: this,
        };
    }

    register(request) {

        if (isFunction(request.execute)) {

            this.queue.requests.push(request);

            if (!this.queue.isRunning) {
                this._run();
            }

            return request;

        } else {
            throw new Error("RequestHandler: request is not a function.");
        }

    }

    _run() {
        if (this.queue.requests.length > 0) {
            //console.log(`Requests in queue: ${this.queue.requests.length}`);
            this.queue.isRunning = true;
            let request = this.queue.requests.shift();
            this._handle(request);
        } else {
            this.queue.isRunning = false;
            //console.log("Requests queue is empty");
        }
    }

    pause() {
        //
    }


    _handle(request) {
        console.log(`Executing request: ${request.name ? request.name : request.id}`);
        request.startedAt = Date.now();

        try {
            request.execute();
        } catch (error) {
            console.warn(`Request execution failed: ${error}`)
        }


        if (request.self.queue.averageSpeed > 0) {
            setTimeout(function () {
                if (!request.completed) {
                    request.self._requestTimeout(request);
                }
            }, (request.self.queue.averageSpeed * 10 > 10000 ? request.self.queue.averageSpeed * 10 : 10000));
        }

    }

    _requestTimeout(request) {
        request.timedOut = true;
        console.warn(`Request: ${request.name ? request.name : request.id} timed out after: ${Date.now() - request.startedAt}ms.`);
        request.self._run();
        return request;
    }

    done(request) {
        request.completed = true;
        request.self.queue.doneRequestsCount++;
        request.completedAt = Date.now();
        request.timeNeeded = request.completedAt - request.startedAt;
        request.self.queue.executionTimeSum += request.timeNeeded;
        request.self.queue.averageSpeed = request.self.queue.executionTimeSum / (request.self.queue.doneRequestsCount > 0 ? request.self.queue.doneRequestsCount : 1);

        let consoleMessage = `Request: ${request.name ? request.name : request.id} | completed in: ${request.timeNeeded}ms | average completion time: ${request.self.queue.averageSpeed}ms.`;
        console.log("%c" + consoleMessage, "color: blue;");

        if (!request.timedOut) {
            // timed out requests already resume queue consumption
            request.self._run();
        }

        return request;
    }
};

/**
 * Space1.Util.ParallelRequestHandler - handles parallel requests
 */
Space1.Util.ParallelRequestHandler = class extends Space1.Util.RequestHandler {

    constructor() {
        super();
    }

    /**
     * @override
     */
    _handle(request) {
        //console.log(`Executing request: ${request.name ? request.name : request.id}`);
        request.startedAt = Date.now();

        try {
            request.execute();
        } catch (error) {
            console.warn(`Request execution failed: ${error}`)
        }


        if (request.self.queue.averageSpeed > 0) {
            setTimeout(function () {
                if (!request.completed) {
                    request.self._requestTimeout(request);
                }
            }, (request.self.queue.averageSpeed * 10 > 10000 ? request.self.queue.averageSpeed * 10 : 10000));
        }

        request.self._run();
    }

    /**
     * @override
     */
    _requestTimeout(request) {
        request.timedOut = true;
        console.warn(`Request: ${request.name ? request.name : request.id} timed out after: ${Date.now() - request.startedAt}ms.`);
        return request;
    }

    /**
     * @override
     */
    done(request) {
        request.completed = true;
        request.self.queue.doneRequestsCount++;
        request.completedAt = Date.now();
        request.timeNeeded = request.completedAt - request.startedAt;
        request.self.queue.executionTimeSum += request.timeNeeded;
        request.self.queue.averageSpeed = request.self.queue.executionTimeSum / (request.self.queue.doneRequestsCount > 0 ? request.self.queue.doneRequestsCount : 1);

        let consoleMessage = `Request: ${request.name ? request.name : request.id} | completed in: ${request.timeNeeded}ms | average completion time: ${request.self.queue.averageSpeed}ms.`;
        console.log("%c" + consoleMessage, "color: orange;");

        return request;
    }
};

/**
 * Space1.UI.videoPlayer
 * handles everything related to video playback
 * */
Space1.UI.videoPlayer = {

    self: null,
    observer: null,

    /**
     * defaultConfig
     * Default players options
     * */
    defaultConfig: {
        controls: (player) => {
            return ['play-large', 'play', 'progress', 'current-time', 'settings', 'mute', 'volume', 'fullscreen'];
        },
        iconUrl: `${Space1.Env.getWebRootPath()}/images/plyr.svg`,
        blankVideo: `${Space1.Env.getWebRootPath()}/videos/blank.mp4`
    },

    /**
     * newPlayer
     * Function that instantiates a new player
     * */
    newPlayer: (playerDOMelement) => {
        $(playerDOMelement).attr("data-player-id", uuidv4());

        let instance = new Plyr(playerDOMelement, Space1.UI.videoPlayer.defaultConfig);
        let instanceLoadAnimation = null;

        instance.on('loadstart', (event) => {
            console.log("VideoPlayer load Start");

            let $videoWrapper = $(playerDOMelement).closest(".plyr");
            $videoWrapper.append($('<div>', {
                class: `plyr__load-animation js-video-loadanimation-${instance.id}`
            }));
            instanceLoadAnimation = new Space1.UI.LoadAnimation(`.js-video-loadanimation-${instance.id}`, 'load-2');
            instanceLoadAnimation.setTooltip("Loading Video...");
            instanceLoadAnimation.stop();

            if (playerDOMelement.preload == "metadata" && instanceLoadAnimation != null) {
                instanceLoadAnimation.start();
            }
        });

        instance.on('error', onError);

        function onError(event) {
            console.warn("VideoPlayer error");
            if (instanceLoadAnimation != null) {
                instanceLoadAnimation.setType("error");
                instanceLoadAnimation.start();
            }
        }

        instance.on('ready', event => {
            //console.log("VideoPlayer ready");
            const instance = event.detail.plyr;

            if (instance.elements.container.offsetWidth < 400) {
                $(instance.elements.controls).find(".plyr__volume > input").hide();
                $(instance.elements.controls).find(".plyr__menu").hide();
            }
            if (instance.elements.container.offsetWidth < 200) {
                //$(instance.elements.controls).find(".plyr__control").hide();
                $(instance.elements.controls).find(".plyr__progress").hide();
                $(instance.elements.controls).find(".plyr__volume").hide();
            }

        });


        instance.on('progress', (event) => {
            //console.log("VideoBuffering: " + instance.buffered);
        });

        instance.on('loadeddata', (event) => {
            //console.log("VideoPlayer loaded Data");
            //instanceLoadAnimation.start();
        });

        instance.on('loadedmetadata', event => {
            //console.log("VideoPlayer loaded MetaData");
            if (playerDOMelement.preload == "metadata" && instanceLoadAnimation != null) {
                instanceLoadAnimation.stop();
            }
        });

        instance.on('enterfullscreen', event => {
            const instance = event.detail.plyr;
            $(instance.elements.controls).find(".plyr__volume > input").show();
            $(instance.elements.controls).find(".plyr__menu").show();
            //$(instance.elements.controls).find(".plyr__control").show();
            $(instance.elements.controls).find(".plyr__progress").show();
            $(instance.elements.controls).find(".plyr__volume").show();

        });

        instance.on('exitfullscreen', event => {
            const instance = event.detail.plyr;
            if (instance.elements.container.offsetWidth < 400) {
                $(instance.elements.controls).find(".plyr__volume > input").hide();
                $(instance.elements.controls).find(".plyr__menu").hide();
            }
            if (instance.elements.container.offsetWidth < 200) {
                //$(instance.elements.controls).find(".plyr__control").hide();
                $(instance.elements.controls).find(".plyr__progress").hide();
                $(instance.elements.controls).find(".plyr__volume").hide();
            }
        });

        Space1.UI.videoPlayer.currentInstances.push(instance);

    },

    /**
     * currentInstances
     * This property gives access to a list of all the video player instances currently on page
     * */
    currentInstances: [],

    /**
     * currentInstances
     * This property gives access to a list of all the video player instances currently on page
     * */
    pauseAll: function () {
        let nowPlaying = Space1.UI.videoPlayer.currentInstances.filter((player) => player.playing);
        for (player of nowPlaying) {
            player.pause();
        }
    },

    /**
     * refresh
     * This function re inits all video player instances
     *
     init: function () {
        Space1.UI.videoPlayer.currentInstances = Array.from(document.querySelectorAll('video:not(.js-native-video-player)')).map(p => Space1.UI.videoPlayer.newPlayer(p));
        return Space1.UI.videoPlayer.currentInstances;
    },*/

    /**
     * autoinit
     * Automatically init every new video added to DOM
     * */
    autoinit: function () {
        Space1.UI.videoPlayer.observer = new MutationObserver(function (mutations) {
            if (document.contains($("video")[0])) {
                $("video:not(.js-native-video-player)").each(function (index, element) {
                    if (!$(this).parent().hasClass("js-native-video-player-container") && !$(this).attr("data-player-id")) {
                        Space1.UI.videoPlayer.newPlayer(this);
                    }
                })
            }
        });

        Space1.UI.videoPlayer.observer.observe(document, {
            attributes: false,
            childList: true,
            characterData: false,
            subtree: true
        });
    },

    stopAutoInit: function () {
        Space1.UI.videoPlayer.observer.disconnect();
    }

};

Space1.UI.videoPlayer.autoinit();

Space1.UI.fileInput = {
    init(el, onChangeCallback) {
        const fileInput = el.querySelector('[type="file"]')
        const label = el.querySelector('[data-js-label]')

        fileInput.onchange = function (event) {
            if (!fileInput.value) {
                return;
            }

            let value = fileInput.value.replace(/^.*[\\\/]/, '');
            el.className += ' -chosen';
            label.innerText = value;

            onChangeCallback(event);
        }
    }
};

/**
 * Space1.UI.convertStringtoFunction
 * Returns a js function from a functionName
 * @param {string} functionName
 *
 * example: Space1.Util.convertStringtoFunction("level1.midLevel.myFunction")(arg1, arg2, ...);
 */
Space1.Util.convertStringtoFunction = function (functionName) {

    var nullFunc = function () {
    }; // Fallback Null-Function
    var ret = window; // Top level namespace

    // If null/undefined string, then return a Null-Function
    if (functionName == null) return nullFunc;

    // Convert string to function name
    functionName.split('.').forEach(function (key) {
        ret = ret[key];
    });

    // If function name is not available, then return a Null-Function else the actual function
    return (ret == null ? nullFunc : ret);

};

/**
 * Space1.Util.isJson
 * Returns a bool
 * @param {string} item
 *
 */
Space1.Util.isJson = function (item) {
    item = typeof item !== "string"
        ? JSON.stringify(item)
        : item;

    try {
        item = JSON.parse(item);
    } catch (e) {
        return false;
    }

    if (typeof item === "object" && item !== null) {
        return true;
    }

    return false;
};

/**
 * Space1.Util.isFunction
 * Returns true if parameter is a function
 * @param {Object} check
 */
Space1.Util.isFunction = function (check) {
    return isFunction(check);
}.bind(isFunction);


/**
 * Space1.UI.UserBadge
 * Returns a small inline user badge
 * TODO: write component
 */
Space1.UI.UserBadge = class {
    constructor(user = {
        name: 'user',
        id: null,
        branchName: ''
    }, size = "normal") {

        const defaultUser = {
            name: 'user',
            id: null,
            branchName: ''
        };

        this.user = {...defaultUser, ...user};

        this.isCurrentUser = Space1.User.Current.id == this.user.id;
        this.userColor = Space1.UI.Colors.generateFromString(`${this.user.id}-AB-${this.user.name}`);

        this._dom = {
            $container: $('<span>', {class: `space1-user space1-user--${size}`}),
            $slideOut: $('<span>', {class: 'space1-user__slide'})
        };

        this._buildDom();
    }

    $dom(self = this) {
        return self._dom.$container.clone();
    }

    _buildDom(self = this) {
        self._dom.$container.attr('user_id', self.user.id);
        //self._dom.$container[0].style.setProperty('--userColor', self.userColor);

        if (self.isCurrentUser) {
            self._dom.$container.addClass('space1-user--current');
        }

        self._dom.$container.html(`<i>${self.user.name}</i>`);

        if ((self.user.branchName || {}).length > 0) {
            self._dom.$slideOut.html(self.user.branchName);
            self._dom.$container.append(self._dom.$slideOut);
        }

        return self;
    }
};

/**
 * Space1.UI.Buttons
 * Handles buttons magic
 *
 */
Space1.UI.Buttons = {
    attachEffectTo: function (el) {
        el.style.setProperty('--x', 0 + 'px');
        el.style.setProperty('--y', 0 + 'px');
        $(el).attr('data-sp1-btn_effect', true);

        $(el).mousemove(function (e) {
            //let x = e.pageX - this.offsetLeft - this.offsetParent.offsetLeft;
            //let y = e.pageY - this.offsetTop - this.offsetParent.offsetTop;
            let x = e.offsetX;
            let y = e.offsetY;
            el.style.setProperty('--x', x + 'px');
            el.style.setProperty('--y', y + 'px');
        });
    },

    initDeleteButton: function (el) {
        const $deleteBtn = $(el);

        if (!$deleteBtn.hasClass('js-sp-delete--button')) {
            $deleteBtn.addClass('js-sp-delete--button');
            let deleteUrl = $deleteBtn.attr('formaction');

            let deleteLabelTooltip = tippy($deleteBtn[0], {
                theme: 'light',
                content: Space1.Strings.getKey("Delete")
            });

            let $confirmDeletionContent = $('<div>', {
                class: 'sp1-confirm'
            });
            
            let $confirmButton = $('<button>', {
                class: 'sp-button sp-button--xsmall sp-button--danger'
            }).text(Space1.Strings.getKey("yes").capitalize());

            let $undoButton = $('<button>', {
                class: 'sp-button sp-button--xsmall sp-button--dark'
            }).text(Space1.Strings.getKey("no").capitalize());

            let $buttonGroup = $('<div>', {
                class: 'sp-button-group sp-button-group--inline'
            }).append($confirmButton).append($undoButton);

            $confirmDeletionContent
                .append(`${Space1.Strings.getKey("AreYouSureThatYouWantToDeleteThisItem")}?`)
                .append($buttonGroup);

            const $tooltipAppendTo = $($deleteBtn.data('tooltip-parent'));

            let confirmDeletionTooltip = tippy($deleteBtn[0], {
                theme: 'light',
                interactive: true,
                trigger: 'click',
                arrow: true,
                arrowType: 'round',
                multiple: true,
                content: $confirmDeletionContent[0],
                appendTo: $tooltipAppendTo.length > 0 ? $tooltipAppendTo[0] : "parent"
            });

            $deleteBtn.on('click', (e) => {
                e.stopImmediatePropagation();
                e.preventDefault();
                confirmDeletionTooltip.show();
            });

            $undoButton.click((e) => {
                e.stopImmediatePropagation();
                e.preventDefault();
                confirmDeletionTooltip.hide();
            });

            $confirmButton.click((e) => {
                e.stopImmediatePropagation();
                e.preventDefault();

                $.ajax({
                    url: deleteUrl,
                    success: function (jsViewToInject) {
                        deleteLabelTooltip.hide();
                        deleteLabelTooltip.destroy();
                        confirmDeletionTooltip.hide();
                        confirmDeletionTooltip.destroy();
                        $("#injected-javascript").html(jsViewToInject);
                    }
                });
            });
        }
    },

    observer: new MutationObserver(function () {
        if (document.contains($('.sp-button:not(.sp-button--no-hover_effect)')[0])) {
            $('.sp-button:not(.sp-button--no-hover_effect)').each(function () {
                if (!$(this).attr('data-sp1-btn_effect')) {
                    Space1.UI.Buttons.attachEffectTo(this);
                }

                if ($(this).hasClass('sp-button--delete')) {
                    Space1.UI.Buttons.initDeleteButton(this);
                }
            });
        }
    }),

    init: function () {
        Space1.UI.Buttons.observer.observe(document, {
            attributes: false,
            childList: true,
            characterData: false,
            subtree: true
        });
    }
};

/**
 * Space1.UI.newThumbnail
 * @param {string} id - id of instance
 * @param {string} title - thumbnail header title
 * @param {jQuery} $button - thumbnail button
 * @param {jQuery} $content - thumbnail content
 * @returns {jQuery} jQuery object with thumbnail
 */
Space1.UI.newThumbnail = function (id, title, $button, $content, contentClasses = '', tags = []) {
    let $thumbnailContainer = $('<div>', {class: 'thumbnail space1-thumbnail', id: id});
    let $thumbnailHeader = $('<div>', {class: 'space1-thumbnail__header'});
    $thumbnailHeader.append($('<div>', {class: 'space1-thumbnail__buttons btn-group btn-group-sm sp-button-group'}).append($button));
    $thumbnailHeader.append($('<code>', {class: 'space1-thumbnail__title'}).html(title));
    let $thumbnailContent = $('<div>', {class: `space1-thumbnail__content ${contentClasses}`});
    $thumbnailContent.append($content);

    if (tags.length > 0) {
        let $tagsContainer = $('<ul>', {class: 'space1-thumbnail__tags'});

        tags.forEach(t => {
            $tagsContainer.append($('<li>').text(t));
        });

        $thumbnailContent.append($tagsContainer);
    }

    $thumbnailContainer.append($thumbnailHeader).append($thumbnailContent);
    return $thumbnailContainer;
};


/**
 * Space1.UI.newThumbnail
 * @param {string} id - id of instance
 * @param {string} title - thumbnail header title
 * @param {jQuery} $button - thumbnail button
 * @param {jQuery} $content - thumbnail content
 * @returns {jQuery} jQuery object with thumbnail
 */
Space1.UI.newThumbnailMulticolor = function (id, title, $button, $content, contentClasses = '', tags = [], backgroundClass = '') {
    let $thumbnailContainer = $('<div>', {class: `thumbnail space1-thumbnail ${backgroundClass}`, id: id});
    let $thumbnailHeader = $('<div>', {class: 'space1-thumbnail__header'});
    $thumbnailHeader.append($('<div>', {class: 'space1-thumbnail__buttons btn-group btn-group-sm sp-button-group'}).append($button));
    $thumbnailHeader.append($('<code>', {class: 'space1-thumbnail__title'}).html(title));
    let $thumbnailContent = $('<div>', {class: `space1-thumbnail__content ${contentClasses}`});
    $thumbnailContent.append($content);

    if (tags.length > 0) {
        let $tagsContainer = $('<ul>', {class: 'space1-thumbnail__tags'});

        tags.forEach(t => {
            $tagsContainer.append($('<li>').text(t));
        });

        $thumbnailContent.append($tagsContainer);
    }

    $thumbnailContainer.append($thumbnailHeader).append($thumbnailContent);
    return $thumbnailContainer;
};

/**
 * @typedef {Object} Space1.UI.Thumbnail.options
 * @property {String} [Space1.UI.Thumbnail.options.id] Dom elements identifiers
 * @property {String} [Space1.UI.Thumbnail.options.title] Thumbnail title
 * @property {jQuery} [Space1.UI.Thumbnail.options.$buttons] jQuery Object with buttons or other interactions
 * @property {jQuery} [Space1.UI.Thumbnail.options.$content] jQuery Object with thumbnail content
 * @property {String} [Space1.UI.Thumbnail.options.contentClass] additional content classes
 * @property {Array} [Space1.UI.Thumbnail.options.variants] ex. ['fluid', 'flat']
 */

/**
 * @namespace Space1.UI.Thumbnail
 * @param {Space1.UI.Thumbnail.options} options - init options object
 * @type {Space1.UI.Thumbnail}
 */
Space1.UI.Thumbnail = class {

    /**
     * @param {Space1.UI.Thumbnail.options} options - init options object
     */
    constructor(options) {
        const defaultOptions = {
            id: Space1.Util.newGuid().toSafeID(),
            title: null,
            $buttons: null,
            $content: null,
            contentClasses: null,
            variants: []
        };

        this.options = {...defaultOptions, ...options};

        this._dom = {
            $container: null,
            $headerContainer: null,
            $title: null,
            $buttonsContainer: null,
            $content: null,
        };

        try {
            this._buildDom();
        } catch (e) {
            console.log("Unable to init Thumbnail.", e);
        }
    }

    _buildDom() {
        this._dom.$container = $('<div>', {
            class: `thumbnail ${this.ns}`,
            id: this.options.id
        });
        this.options.variants.map((variant) => this.dom.$container.addClass(`${this.ns}--${variant}`));

        this._dom.$headerContainer = $('<div>', {
            class: `${this.ns}__header`
        });
        this._dom.$headerContainer.appendTo(this._dom.$container);

        this._dom.$buttonsContainer = $('<div>', {
            class: `${this.ns}__buttons btn-group btn-group-sm sp-button-group`
        }).append(this.options.$buttons);
        this._dom.$buttonsContainer.appendTo(this._dom.$headerContainer);

        this._dom.$title = $('<code>', {
            class: 'space1-thumbnail__title'
        }).html(this.options.title);
        this._dom.$title.appendTo(this._dom.$headerContainer);

        this._dom.$content = $('<div>', {
            class: `${this.ns}__content ${this.options.contentClasses}`
        }).append(this.options.$content);

        this._dom.$content.appendTo(this._dom.$container);
    }

    set title(title) {
        this._dom.$title.empty();
        this._dom.$title.html(title);
    }

    set $content($content) {
        this._dom.$content.empty();
        this._dom.$content.append($content);
    }

    get $dom() {
        return this._dom.$container;
    }

    get dom() {
        return this._dom;
    }
};
Space1.UI.Thumbnail.prototype.ns = "space1-thumbnail";

/**
 * Space1.UI.assetBundleInfoTooltips
 */
Space1.UI.assetBundleInfoTooltips = {
    init() {
        let $triggers = $('[data-assetbundletooltip]');

        function guessAndGetIcon(guess) {
            let iconName = 'fa-cube';
            switch (guess) {
                case "win64":
                    iconName = 'fas fa-laptop fa-lg space1-color-windows';
                    break;
                case "wsa":
                    iconName = 'fas fa-glasses fa-lg space1-color-windows';
                    break;
                case "ios":
                    iconName = 'fab fa-apple fa-lg space1-color-apple';
                    break;
                case "android":
                    iconName = 'fab fa-android fa-lg space1-color-android';
                    break;
            }
            return $('<i>', {class: `${iconName}`});
        }

        $triggers.each(
            function (index) {
                let trigger = this;
                let spaceObjectModelId = $(trigger).data('spaceobjectid');
                let title = tippy(trigger, {
                    content: 'Unity Asset Bundles',
                    theme: "light"
                });

                let tooltip = tippy(trigger, {
                    content: 'Loading...',
                    animateFill: false,
                    animation: 'fade',
                    flipOnUpdate: true,
                    theme: 'light',
                    interactive: true,
                    trigger: 'click',
                    arrow: true,
                    arrowType: 'round',
                    placement: 'bottom',
                    multiple: true,

                    onShow(instance) {
                        // We can monkey-patch the instance's state object with our own state
                        if (instance.state.ajax === undefined) {
                            instance.state.ajax = {
                                isFetching: false,
                                canFetch: true,
                            }
                        }

                        // Now we will avoid initiating a new request unless the old one
                        // finished (`isFetching`).
                        // We also only want to initiate a request if the tooltip has been
                        // reset back to Loading... (`canFetch`).
                        if (instance.state.ajax.isFetching || !instance.state.ajax.canFetch) {
                            return
                        }

                        fetch(`${Space1.Env.getWebRootPath()}/api/spaceobjects/GetAssetBundleVersions/${spaceObjectModelId}?api-version=1.0`)
                            .then(response => response.json())
                            .then(json => {
                                // render json
                                if (Space1.Env.is("LOCAL") || Space1.Env.is("DEV")) console.log('Received AssetBundleVersions:', json);

                                let $container = $('<ul>', {class: 'tooltip-inner-list list-group list-group-unbordered'});
                                let $containerTitle = $('<p>', {class: 'h-gradient-text--c1 text-center tooltip-title'});
                                $container.append($('<i>', {class: 'sp-vc-icons icon-unity h-gradient-text--c1 fa-2x'}));
                                $containerTitle.append($('<span>').text(' Unity Asset Bundles'));
                                $containerTitle.appendTo($container);

                                const platformNames = Object.keys(json);
                                for (let i in platformNames) {
                                    let platform = platformNames[i];
                                    if (platform == 'spaceObjectModelId') continue;

                                    let $platformRow = $('<li>', {class: 'list-group-item space1-badge-list space1-badge-list--padded'});

                                    let $platformIconContainer = $('<div>', {class: 'space1-badge-list__icon'});
                                    let $platformIcon = guessAndGetIcon(platform);
                                    $platformIcon.appendTo($platformIconContainer);
                                    $platformRow.append($platformIconContainer);

                                    if (json[platform].length > 0) {
                                        // there are asset bundle versions for this platform
                                        let $unityVersionsBadges = json[platform].map(unityVersion => $('<span>', {class: 'space1-badge'}).text(unityVersion));
                                        $platformRow.append($unityVersionsBadges)
                                    } else {
                                        $platformRow.append($('<span>', {class: 'text-muted'}).text('---'));
                                    }

                                    $container.append($platformRow);
                                }

                                instance.setContent($container[0]);
                            })
                            .catch(error => {
                                console.log(error);
                            })
                            .finally(() => {
                                // Make sure to set it back to false so new requests can be
                                // initiated
                                instance.state.ajax.isFetching = false
                            })
                    },
                    onHidden(instance) {
                        instance.setContent('Loading...');
                        instance.state.ajax.canFetch = true
                    },
                });
            }
        );
    }
};

/* Space1.Util.camelizeKeys */
Space1.Util.camelizeKeys = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map(v => Space1.Util.camelizeKeys(v));
    } else if (obj !== null && obj.constructor === Object) {
        return Object.keys(obj).reduce(
            (result, key) => ({
                ...result,
                [key.toCamelCase()]: Space1.Util.camelizeKeys(obj[key]),
            }),
            {},
        );
    }
    return obj;
};

/**
 * Space1.UI.autoScrollOnHover
 */
Space1.UI.autoScrollOnHover = {
    newFactory: function (selector) {
        $(`${selector}:not(.js-autoscrolling)`).each((i, e) => {
            this.instances.push(new this.Autoscroller(e));
        });
    },
    instances: [],
    Autoscroller: class {
        constructor(element) {
            this.$element = $(element);
            this.$element.addClass('.js-autoscrolling');
            this.autoscrollActive = false;
            this.upScroller = null;
            this.downScroller = null;
            this.speed = 1;
            this.elementCenter = this.$element.height() / 2;
            this.mouse = {
                x: 0,
                y: 0,
                pressed: false,
            };

            this._initListeners();
        }

        _initListeners() {
            this._initHoverListener();
            this._initMouseDownListener();
        }

        _initMouseDownListener() {
            let self = this;
            $(document).mousedown(function () {
                self.mouse.pressed = true;
                console.log("mousedown");
            });

            $(document).mouseup(function () {
                self.mouse.pressed = false;
                console.log("mouseup");
            });
        }

        _initHoverListener() {
            this.$element.mouseenter(() => {
                if (this.mouse.pressed) {
                    this.autoscrollActive = true;
                    clearTimeout(this.upScroller);
                    this.upScroller = null;
                    clearTimeout(this.downScroller);
                    this.downScroller = null;
                    this.$element.on('mousemove', this.hoverHandler.bind(this));
                }
            });

            this.$element.mouseleave(() => {
                this.autoscrollActive = false;
                clearTimeout(this.upScroller);
                this.upScroller = null;
                clearTimeout(this.downScroller);
                this.downScroller = null;

                this.$element.off('mousemove', this.hoverHandler);
            });

            let self = this;
            this.$element.mousemove(function (e) {

            });
        }

        hoverHandler(event) {
            this.elementCenter = this.$element.height() / 2;
            if (this.autoscrollActive) {
                this.mouse.x = event.pageX - this.$element.offset().left;
                this.mouse.y = event.pageY - this.$element.offset().top;

                if (this.upScroller != null) {
                    clearTimeout(this.upScroller);
                }

                if (this.downScroller != null) {
                    clearTimeout(this.downScroller);
                }

                this.speed = Math.pow(Math.abs(this.elementCenter - this.mouse.y), 2) / 10000;

                if (this.mouse.y > this.elementCenter) {
                    this._scrollDown();
                }

                if (this.mouse.y < this.elementCenter) {
                    this._scrollUp();
                }
            }
        }

        _scrollDown() {
            this.downScroller = setTimeout(() => {
                if (this.autoscrollActive && this.mouse.pressed) {
                    const currentPosition = this.$element.scrollTop();
                    this.$element.scrollTop(currentPosition + 1 + this.speed);
                    this._scrollDown();
                }
            }, 1 / this.speed);
        }

        _scrollUp() {
            this.upScroller = setTimeout(() => {
                if (this.autoscrollActive && this.mouse.pressed) {
                    const currentPosition = this.$element.scrollTop();
                    this.$element.scrollTop(currentPosition - 1 - this.speed);
                    this._scrollUp();
                }
            }, 1 / this.speed);
        }
    },
};

/**
 * Space1.UI.colorPicker
 */
Space1.UI.colorPicker = {
    newFactory: function (selector) {
        $(`${selector}`).each((i, e) => {
            if (!e.classList.contains('js-color-picker-attached')) {
                this.instances.push(new this.Picker(e));
            }
        });
    },
    instances: [],
    Picker: class {
        constructor(element) {
            this.$pickerElement = $(element);
            this.$pickerContainer = $('<div>', {
                class: "sp-color-picker--container"
            });
            this.picker = null;
            this.$pickerInput = $(`#${this.$pickerElement.data('colorpicker-input')}`);
            this.pickerTooltip = null;
            if (this.$pickerInput.length > 0) {
                this.init();
            }

            this.$pickerElement.addClass('js-color-picker-attached');
        }

        init() {
            $("body").append(this.$pickerContainer);

            if (this.$pickerInput.val() != '') {
                this.$pickerContainer.attr('acp-color', this.$pickerInput.val());
            }

            this.pickerTooltip = new tippy(this.$pickerElement[0], {
                content: this.$pickerContainer[0],
                animateFill: false,
                animation: 'fade',
                flipOnUpdate: true,
                theme: 'light',
                interactive: true,
                trigger: 'click',
                arrow: false,
                arrowType: 'round',
            });

            this.picker = AColorPicker.from(this.$pickerContainer)
                .on('change', (picker, color) => {
                    this.$pickerElement.css('background-color', color);
                    this.$pickerElement.text(color);
                    this.$pickerInput.val(color);
                });
        }
    }
};

/**
 * Space1.UI.partnerLicenseStatusTooltips
 */
Space1.UI.partnerLicenseStatusTooltips = {
    init() {
        let $triggers = $('[data-partnerlicensestatustooltip]');

        $triggers.each(
            function (index) {
                let trigger = this;
                let partnerId = $(trigger).data('partnerid');
                let title = tippy(trigger, {
                    content: Space1.Strings.getKey('PartnerLicensingStatus'),
                    theme: "light"
                });

                let tooltip = tippy(trigger, {
                    content: 'Loading...',
                    animateFill: false,
                    animation: 'fade',
                    flipOnUpdate: true,
                    theme: 'light',
                    interactive: true,
                    trigger: 'click',
                    arrow: true,
                    arrowType: 'round',
                    placement: 'bottom',
                    multiple: true,

                    onShow(instance) {
                        // We can monkey-patch the instance's state object with our own state
                        if (instance.state.ajax === undefined) {
                            instance.state.ajax = {
                                isFetching: false,
                                canFetch: true,
                            }
                        }

                        // Now we will avoid initiating a new request unless the old one
                        // finished (`isFetching`).
                        // We also only want to initiate a request if the tooltip has been
                        // reset back to Loading... (`canFetch`).
                        if (instance.state.ajax.isFetching || !instance.state.ajax.canFetch) {
                            return
                        }

                        fetch(`${Space1.Env.getWebRootPath()}/Partners/GetPartnerLicenseStatusAsync/${partnerId}?api-version=1.0`)
                            .then(response => response.json())
                            .then(json => {
                                // render json
                                if (Space1.Env.is("LOCAL") || Space1.Env.is("DEV")) console.log('Received Partner Licensing status:', json);

                                let $container = $('<ul>', {class: 'tooltip-inner-list list-group list-group-unbordered'});

                                $container.append($('<i>', {class: 'fas fa-ticket-alt h-gradient-text--c1 fa-2x'}));
                                let $containerTitle = $('<p>', {class: 'h-gradient-text--c1 text-center tooltip-title'});
                                $containerTitle.append($('<span>').text(Space1.Strings.getKey('PartnerLicensingStatus')));
                                $containerTitle.appendTo($container);

                                let $standardTitle = $('<p>', {class: 'h-gradient-text--c1 text-center tooltip-title'});
                                $standardTitle.append($('<span>').text(Space1.Strings.getKey('Standard')));
                                $standardTitle.appendTo($container);


                                let $table = $('<table>', {
                                    class: 'table table-bordered table-striped table-condensed table_space'
                                });
                                let $thead = $('<thead>');
                                let $tbody = $('<tbody>');

                                $thead.appendTo($table);
                                $tbody.appendTo($table);

                                function addRow(head, body, type = 'body', ...cells) {
                                    let $row = $('<tr>');
                                    cells.map((cell) => {
                                        let $cell = null;
                                        if (type == 'body') {
                                            $cell = $('<td>');
                                        } else if (type == 'head') {
                                            $cell = $('<th>');
                                        }
                                        $cell.appendTo($row);
                                        $cell.html(cell);
                                    });

                                    if (type == 'body') {
                                        $row.appendTo(body);
                                    } else if (type == 'head') {
                                        $row.appendTo(head);
                                    }
                                }

                                addRow($thead, $tbody, 'head',
                                    '',
                                    'Essential',
                                    'Advanced',
                                    'Expert',
                                    'Elite'
                                );

                                addRow($thead, $tbody, 'body',
                                    Space1.Strings.getKey('Available'),
                                    (json.availableEssential >= 0 ? json.availableEssential : '<strong class="text-danger">' + Math.abs(json.availableEssential) + '</strong>'),
                                    (json.availableAdvanced >= 0 ? json.availableAdvanced : '<strong class="text-danger">' + Math.abs(json.availableAdvanced) + '</strong>'),
                                    (json.availableExpert >= 0 ? json.availableExpert : '<strong class="text-danger">' + Math.abs(json.availableExpert) + '</strong>'),
                                    (json.availableElite >= 0 ? json.availableElite : '<strong class="text-danger">' + Math.abs(json.availableElite) + '</strong>')
                                );

                                addRow($thead, $tbody, 'body',
                                    Space1.Strings.getKey('Used'),
                                    (json.usedEssential >= 0 ? json.usedEssential : '<strong class="text-danger">' + Math.abs(json.usedEssential) + '</strong>'),
                                    (json.usedAdvanced >= 0 ? json.usedAdvanced : '<strong class="text-danger">' + Math.abs(json.usedAdvanced) + '</strong>'),
                                    (json.usedExpert >= 0 ? json.usedExpert : '<strong class="text-danger">' + Math.abs(json.usedExpert) + '</strong>'),
                                    (json.usedElite >= 0 ? json.usedElite : '<strong class="text-danger">' + Math.abs(json.usedElite) + '</strong>')
                                );

                                addRow($thead, $tbody, 'body',
                                    Space1.Strings.getKey('Purchased'),
                                    (json.purchasedEssential >= 0 ? json.purchasedEssential : '<strong class="text-danger">' + Math.abs(json.purchasedEssential) + '</strong>'),
                                    (json.purchasedAdvanced >= 0 ? json.purchasedAdvanced : '<strong class="text-danger">' + Math.abs(json.purchasedAdvanced) + '</strong>'),
                                    (json.purchasedExpert >= 0 ? json.purchasedExpert : '<strong class="text-danger">' + Math.abs(json.purchasedExpert) + '</strong>'),
                                    (json.purchasedElite >= 0 ? json.purchasedElite : '<strong class="text-danger">' + Math.abs(json.purchasedElite) + '</strong>')
                                );


                                $container.append($table);

                                //perpetual
                                let $perpetualTitle = $('<p>', {class: 'h-gradient-text--c1 text-center tooltip-title'});
                                $perpetualTitle.append($('<span>').text(Space1.Strings.getKey('Perpetual')));
                                $perpetualTitle.appendTo($container);

                                let $perpetualTable = $('<table>', {
                                    class: 'table table-bordered table-striped table-condensed table_space'
                                });

                                let $tperpetualHead = $('<thead>');
                                let $tperpetualbody = $('<tbody>');

                                $tperpetualHead.appendTo($perpetualTable);
                                $tperpetualbody.appendTo($perpetualTable);


                                addRow($tperpetualHead, $tperpetualbody, 'head',
                                    '',
                                    'Essential',
                                    'Advanced',
                                    'Expert',
                                    'Elite'
                                );

                                addRow($tperpetualHead, $tperpetualbody, 'body',
                                    Space1.Strings.getKey('Available'),
                                    (json.availableEssential >= 0 ? json.perpetualAvailableEssential : '<strong class="text-danger">' + Math.abs(json.perpetualAvailableEssential) + '</strong>'),
                                    (json.availableAdvanced >= 0 ? json.perpetualAvailableAdvanced : '<strong class="text-danger">' + Math.abs(json.perpetualAvailableAdvanced) + '</strong>'),
                                    (json.availableExpert >= 0 ? json.perpetualAvailableExpert : '<strong class="text-danger">' + Math.abs(json.perpetualAvailableExpert) + '</strong>'),
                                    (json.availableElite >= 0 ? json.perpetualAvailableElite : '<strong class="text-danger">' + Math.abs(json.perpetualAvailableElite) + '</strong>')
                                );

                                addRow($tperpetualHead, $tperpetualbody, 'body',
                                    Space1.Strings.getKey('Used'),
                                    (json.usedEssential >= 0 ? json.perpetualUsedEssential : '<strong class="text-danger">' + Math.abs(json.perpetualUsedEssential) + '</strong>'),
                                    (json.usedAdvanced >= 0 ? json.perpetualUsedAdvanced : '<strong class="text-danger">' + Math.abs(json.perpetualUsedAdvanced) + '</strong>'),
                                    (json.usedExpert >= 0 ? json.perpetualUsedExpert : '<strong class="text-danger">' + Math.abs(json.perpetualUsedExpert) + '</strong>'),
                                    (json.usedElite >= 0 ? json.perpetualUsedElite : '<strong class="text-danger">' + Math.abs(json.perpetualUsedElite) + '</strong>')
                                );

                                addRow($tperpetualHead, $tperpetualbody, 'body',
                                    Space1.Strings.getKey('Purchased'),
                                    (json.purchasedEssential >= 0 ? json.perpetualPurchasedEssential : '<strong class="text-danger">' + Math.abs(json.perpetualPurchasedEssential) + '</strong>'),
                                    (json.purchasedAdvanced >= 0 ? json.perpetualPurchasedAdvanced : '<strong class="text-danger">' + Math.abs(json.perpetualPurchasedAdvanced) + '</strong>'),
                                    (json.purchasedExpert >= 0 ? json.perpetualPurchasedExpert : '<strong class="text-danger">' + Math.abs(json.perpetualPurchasedExpert) + '</strong>'),
                                    (json.purchasedElite >= 0 ? json.perpetualPurchasedElite : '<strong class="text-danger">' + Math.abs(json.perpetualPurchasedElite) + '</strong>')
                                );


                                $container.append($perpetualTable);

                                instance.setContent($container[0]);
                            })
                            .catch(error => {
                                console.log(error);
                            })
                            .finally(() => {
                                // Make sure to set it back to false so new requests can be
                                // initiated
                                instance.state.ajax.isFetching = false
                            })
                    },
                    onHidden(instance) {
                        instance.setContent('Loading...');
                        instance.state.ajax.canFetch = true
                    },
                });
            }
        );
    }
};


/**
 * Space1.UI.Tabs
 * @param {string} id - id of instance
 * @param {Array.<{name: Strings, $content: jQuery}>} tabs - array of tabs; example of tab: -> { name: 'Images', $content: $('<img>', {src: 'image.jpg'}) }
 * @param {jQuery} $parent - $parent object: tabs will be appended here
 */
Space1.UI.Tabs = class {

    constructor(id, tabs = [], $parent) {
        this.id = 'tabs-' + Space1.Util.newGuid();

        this.tabs = [];

        this.dom = {
            $container: $('<div>', {class: 'space1-tabs space1-tabs--nomargin', id: this.id}),
            $tabsHeader: $('<ul>', {class: 'nav nav-tabs', role: 'tablist'}),
            $tabsContent: $('<div>', {class: 'tab-content'}),
            $parent: $parent
        };

        this._buildDom(tabs);
    }

    _buildDom(tabs, self = this) {

        if (self.tabs.length > 0) {

            let isFirstTab = true;
            tabs.map(tab => {
                self.addTab(tab.name, tab.$content, isFirstTab);
                isFirstTab = false;
            });
        }

        self.dom.$container.append(self.dom.$tabsHeader);
        self.dom.$container.append(self.dom.$tabsContent);

        self.dom.$container.appendTo(self.dom.$parent);

        return self;
    }

    addTab(tabName, $content, active = false, self = this) {
        let $tabSelector = $('<li>', {role: 'presentation'}).append($('<a>', {
            'href': `#${self.id}-${tabName.toSafeID()}`,
            'aria-controls': `${self.id}-${tabName.toSafeID()}`,
            'role': 'tab',
            'data-toggle': 'tab'
        }).html(tabName));

        let $tabContent = $('<div>', {
            role: 'tabpanel',
            id: `${self.id}-${tabName.toSafeID()}`,
            class: 'tab-pane fade'
        }).append($content);

        if (active || self.tabs.length == 0) {
            $tabSelector.addClass('active');
            $tabContent.addClass('active in');
        }

        $tabSelector.appendTo(self.dom.$tabsHeader);
        $tabContent.appendTo(self.dom.$tabsContent);

        self.tabs.unshift({name: tabName, $content: $content});

        return self;
    }

    removeTab(self = this) {
        // TODO
    }

};

Space1.UI.Tabs.initScrollableTabs = function () {
    $('.nav-tabs.auto-scroll').each(function () {
        let $navbar = $(this);
        $navbar.find('li a[data-toggle="tab"]').on('shown.bs.tab', function () {
            let $container = $(this).parent();
            $navbar.stop().animate({scrollLeft: $container.position().left}, 500);
        });
    });
};

Space1.UI.Tabs.initAnchorNavigation = function () {

    // With HTML5 history API, we can easily prevent scrolling!
    $('.nav-save-history').each(function () {
        let $navbar = $(this);
        let historyId = $navbar.data('history-id');

        // set history on tab show
        $navbar.find('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
            sessionStorage.setItem(historyId, JSON.stringify(e.target.hash));
            console.log(e.target.hash);
        });

        // get history from sessionStorage
        let tabToOpen = sessionStorage.getItem(historyId);
        if (tabToOpen) {
            try {
                console.log(JSON.parse(tabToOpen));
                $(`a[href="${JSON.parse(tabToOpen)}"]`).tab('show');
            } catch (error) {
            }
        }
    });
};

/**
 * Space1.UI.Modal
 */
Space1.UI.Modal = class {

    constructor(options) {

        this.options = $.extend({
            id: 'modal-' + Space1.Util.newGuid(),
            title: '--',
            $content: $('<div>').html('--'),
            remote: false,
            backdrop: 'static',
            size: 'small',
            defaultActions: true,
            onlyCloseAction: false,
            autodestruction: true,
            autodestructionWait: 10000,
            footer: true,
            onShowCallback: (modal) => {
            },
            onShownCallback: (modal) => {
                console.log("onshowncallback 🐱‍💻")
            },
            onHideCallback: (modal) => {
            },
            onHiddenCallback: (modal) => {
            },
            beforeDestroyCallback: (modal) => {
            },
            $parent: $('body'),
        }, options);

        this.now = {
            isOpen: false,
            isDestroyed: false
        };

        this.debug = Space1.Env.is("dev") || Space1.Env.is("local");

        this.sizeClasses = {
            small: "modal-sm",
            large: "modal-lg",
            full: "modal--fullscreen",
        };

        this.actionClasses = {
            primary: "btn btn-primary sp-button sp-button--medium sp-button--rounded sp-button--hover",
            secondary: "btn btn-default sp-button sp-button--dark sp-button--medium sp-button--rounded sp-button--hover"
        };

        this.dom = {
            $modal: $('<div>', {class: 'modal', role: 'dialog', tabindex: '-1', id: this.options.id}),
            $dialog: $('<div>', {class: 'modal-dialog', role: 'document'}),
            $content: $('<div>', {class: 'modal-content js-modal-content'}),
            $header: $('<div>', {class: 'modal-header'}),
            $title: $('<h4>', {class: 'modal-title h-gradient-text--c1'}),
            $fullscreenBtn: $('<div>', {
                'class': 'modal-fs_toggle modal-interaction',
                'type': 'button'
            }).html('<span>&#10530;</span>'),
            $closer: $('<button>', {
                'class': 'close modal-interaction',
                'type': 'button',
                'data-dismiss': 'modal',
                'aria-hidden': 'true'
            }).html('<span>&times;</span>'),
            $body: $('<div>', {class: 'modal-body'}),
            $footer: $('<div>', {class: 'modal-footer'}),
        };

        this.actions = [];

        this.init();
    }

    init(self = this) {
        if (this.debug && self.now.isDestroyed) {
            console.log(`Modal ${this.options.id} self-rebuilt after destruction.`);
        }

        if (!self.now.isDestroyed) {
            self._appendTo(self.options.$parent)
                .setOnShowCallback(self.options.onShowCallback)
                .setOnShownCallback(self.options.onShownCallback)
                .setOnHideCallback(self.options.onHideCallback)
                .setOnHiddenCallback(self.options.onHiddenCallback);
        } else {
            self._initActionButtonsListeners(self);
        }

        self._buildDom()
            .setSize(self.options.size)
            .setTitle(self.options.title)

        if (!self.options.remote) {
            self.setContent(self.options.$content);
        } else {
            $.ajax({
                url: self.options.remote,
                success: function (modalContent) {
                    self.setHtmlContent(modalContent);
                    self._attachEventsListener();
                    self.dom.$modal.trigger('loaded.bs.modal');
                }
            });
        }

        self._attachEventsListener();

        self.now.isDestroyed = false;

        if (self.options.defaultActions) {
            self.addAction({
                id: 'cancel',
                label: Space1.Strings.getKey('Cancel'),
                type: 'button',
                style: 'secondary',
                align: 'right',
                onClick: (event, self) => {
                    self.close(self)
                },
                disabled: false,
            }).addAction({
                id: 'submit',
                label: Space1.Strings.getKey('Confirm'),
                type: 'submit',
                style: 'primary',
                align: 'right',
                onClick: (event, self) => {
                },
                disabled: false,
            });
        } else if (self.options.onlyCloseAction) {
            self.addAction({
                id: 'cancel',
                label: Space1.Strings.getKey('Close'),
                type: 'button',
                style: 'secondary',
                align: 'right',
                onClick: (event, self) => {
                    self.close(self)
                },
                disabled: false,
            });
        }


        return self;
    }

    open(self = this) {
        if (this.now.isDestroyed) {
            this.init();
        }

        self.dom.$modal.modal("show");

        Space1.UI.Modal.addModalToStack(self.options.id);
        return self;
    }

    close(self = this) {
        self.dom.$modal.modal("hide");

        return self;
    }

    toggle(self = this) {
        if (this.now.isDestroyed) {
            this.init();
        }

        self.dom.$modal.modal("toggle");

        return self;
    }

    setTitle(title, self = this) {
        self.dom.$title.html(title);

        return self;
    }

    setContent($newContent, self = this) {
        self.dom.$body.empty();
        $newContent.hide();
        self.dom.$body.append($newContent);
        $newContent.fadeIn();
        return self;
    }

    setHtmlContent(content, self = this) {
        self.dom.$content.html(content);
        return self;
    }

    setSize(size, self = this) {
        self.dom.$dialog.addClass(self.sizeClasses[size]);

        return self;
    }

    setOnShowCallback(callback, self = this) {
        Space1.UI.videoPlayer.pauseAll();

        if (Space1.Util.isFunction(callback)) {
            self.options.onShowCallback = callback;
        }

        return self;
    }

    setOnShownCallback(callback, self = this) {
        if (Space1.Util.isFunction(callback)) {
            self.options.onShownCallback = callback;
        }

        return self;
    }

    setOnHideCallback(callback, self = this) {
        Space1.UI.videoPlayer.pauseAll();
        if (Space1.Util.isFunction(callback)) {
            self.options.onShowCallback = callback;
        }

        return self;
    }

    setOnHiddenCallback(callback, self = this) {
        Space1.UI.videoPlayer.pauseAll();
        if (Space1.Util.isFunction(callback)) {
            self.options.onHiddenCallback = callback;
        }

        return self;
    }

    addAction(action, self = this) {
        let newAction = $.extend({
            id: Space1.Util.newGuid(),
            label: 'Button', // es. Confirm
            type: 'submit', // es. submit / button / reset
            style: 'primary', // es. primary / secondary
            align: 'right', // es. left / right
            onClick: (event, self) => {
                console.log('click', self)
            },
            disabled: false,
            visible: true
        }, action);

        newAction.$button = self._buildActionButton(newAction);

        self.actions.push(newAction);
        self.dom.$footer.append(newAction.$button);

        return self;
    }

    enableAction(actionId, self = this) {
        let actionToBeEnabled = self.actions.find(action => action.id == actionId);
        actionToBeEnabled.$button.prop('disabled', false);
        actionToBeEnabled.disabled = false;

        return self;
    }

    disableAction(actionId, self = this) {
        let actionToBeDisabled = self.actions.find(action => action.id == actionId);
        actionToBeDisabled.$button.prop('disabled', true);
        actionToBeDisabled.disabled = true;

        return self;
    }

    removeAction(actionId, self = this) {
        let IndexOfActionToBeRemoved = self.actions.findIndex(action => action.id == actionId);
        if (IndexOfActionToBeRemoved > -1) {
            let actionToBeRemoved = self.actions[IndexOfActionToBeRemoved];
            actionToBeRemoved.$button.off();
            actionToBeRemoved.$button.remove();
            self.actions.splice(IndexOfActionToBeRemoved, 1);
        }

        return self;
    }

    destroy() {
        if (this.debug) {
            console.log(`Modal ${this.options.id} self destroyed after 10 seconds of inactivity.`);
        }

        this.options.beforeDestroyCallback(this);

        this.dom.$modal.empty(); // remove modal from DOM
        this.now.isDestroyed = true;
    }

    _buildActionButton(action, self = this) {
        let $actionButton = $('<button>', {
            id: action.id + '-' + self.options.id,
            type: action.type,
            class: self.actionClasses[action.style],
        }).html(action.label);

        $actionButton.click((event) => {
            action.onClick(event, self);
        });

        if (action.disabled) {
            $actionButton.prop('disabled', true);
        }

        if (!action.visible) {
            $actionButton.css('display', 'none');
        }

        switch (action.align) {
            case 'left':
                $actionButton.addClass('button-left');
                break;
            case 'right':
                $actionButton.addClass('button-right');
                break;
        }

        return $actionButton;
    }

    _initActionButtonsListeners(self = this) {
        self.actions.map(action => {
            action.$button.click((event) => {
                action.onClick(event, self);
            });
        });
    }

    _buildDom(self = this) {

        if (!self.options.remote) {
            self.dom.$content.append(self.dom.$header);

            self.dom.$header.append(self.dom.$title);
            self.dom.$header.append(self.dom.$fullscreenBtn);
            self.dom.$header.append(self.dom.$closer);
            self.dom.$content.append(self.dom.$body);
        }

        if (self.options.footer) {
            self.dom.$content.append(self.dom.$footer);
        }

        self.dom.$dialog.append(self.dom.$content);
        self.dom.$modal.append(self.dom.$dialog);
        self.dom.$modal.data('backdrop', self.options.backdrop);

        return self;
    }

    _appendTo($parent, self = this) {
        self.dom.$modal.appendTo($parent);

        return self;
    }

    _attachEventsListener(self = this) {
        if (!self.now.isDestroyed) {
            self.dom.$modal.on('show.bs.modal', (event) => {
                self.now.isOpen = true;
                self.options.onShowCallback(self);
            });

            self.dom.$modal.on('shown.bs.modal', (event) => {
                self.options.onShownCallback(self);
            });

            self.dom.$modal.on('hide.bs.modal', (event) => {
                self.now.isOpen = false;
                Space1.UI.videoPlayer.pauseAll();
                self.options.onHideCallback(self);
            });

            self.dom.$modal.on('hidden.bs.modal', (event) => {
                self.options.onHiddenCallback(self);

                if (self.options.autodestruction) {

                    if (self.options.autodestructionWait > 0) {
                        self.now.autodestructionTimeout = setTimeout(() => {
                            //  and when it ends, if modal is still closed
                            if (!self.now.isOpen && !self.now.isDestroyed) {
                                // detach from DOM
                                self.destroy();
                            }
                        }, self.options.autodestructionWait);
                    } else {
                        self.destroy();
                    }
                }
            });
        }

        this.dom.$fullscreenBtn.click((event) => {
            event.preventDefault();
            event.stopPropagation();
            this.dom.$dialog.toggleClass('modal--fullscreen');
            this.dom.$modal.trigger("fullscreenChange");
        });

        return self;
    }

    static initFullscreenButtons($modal = null) {
        if (!($modal instanceof jQuery)) {
            $modal = $($modal);
        }

        let modalMinSize = $modal.data('modal-min-size');

        if (!$modal.data('fullscreen-init') && modalMinSize !== 'modal--fullscreen') {
            let $fsButton = null;
            $modal.attr('fullscreen-init', true);

            $fsButton = $modal.find('.modal-fs_toggle').first();
            
            $fsButton.click(function (event) {
                event.preventDefault();
                event.stopPropagation();

                let $modalChangingFullscreen = $(this).closest('.modal');
                let $modalDialog = $modalChangingFullscreen.find('.modal-dialog');

                if ($modalDialog.hasClass('modal--fullscreen')) {
                    $modalDialog.removeClass('modal--fullscreen');
                    $modalDialog.addClass(modalMinSize ? modalMinSize : 'modal-lg');
                } else {
                    $modalDialog.addClass('modal--fullscreen');
                }

                $modalChangingFullscreen.trigger("fullscreenChange");
            });
        }
    }
};
Space1.UI.Modal.openModalsStack = [];

Space1.UI.Modal.addModalToStack = function (modalId) {
    console.log("added modal to stack", $(`#${modalId}`));
    Space1.UI.Modal.openModalsStack.unshift(modalId);
};

Space1.UI.Modal.removeModalFromStack = function (IdToRemove) {
    Space1.UI.Modal.openModalsStack = Space1.UI.Modal.openModalsStack.filter(modalId => modalId !== IdToRemove);
};

Space1.UI.Modal.getBackgroundModalsId = function () {
    return Space1.UI.Modal.openModalsStack.slice(1);
};

Space1.UI.Modal.getForegroundModalId = function () {
    return Space1.UI.Modal.openModalsStack[0];
};

Space1.UI.Search = class {
    constructor(options = {
        container: null,
        searchIconClass: null,
        placeholder: 'Search',
        network: {
            hub: null, // tagsHub
            search: null, // SearchTag
            results: null, // SearchTagResult
            connection: null
        },
        disableCaseInsensitive: false,
        disableHub: false,
        searchFor: null, // SpaceObject,
        searchMode: null, // available modes: 'search-only', 'create-missing', 'create-missing-ajax', 'submit-keyword-ajax'
        suggestionsAcceptedBeforeInit: [], // array of suggestions
        minimumInputLength: 3,
        ajaxResultsContainer: null,
        beforeSearchCallback: (instance) => {

        },
        onSearchCallback: (instance) => {

        },
        onUpdateCallback: () => {

        },
        form: {
            action: null,
            parameterName: null,
            additionalParameters: null,
            accessToken: null
        }
    }) {
        const defaultOptions = {
            container: null,
            searchIconClass: 'sp-vc-icons icon-search',
            placeholder: Space1.Strings.getKey('search/input/placeholder'),
            network: {
                hub: null, // tagsHub
                search: null, // SearchTag
                results: null, // SearchTagResult
                connection: null
            },
            disableHub: false,
            searchFor: null, // SpaceObject,
            searchMode: 'search-only',
            suggestionsAcceptedBeforeInit: [], // array of suggestions
            preInput: '', // what to input on init
            minimumInputLength: 3, // search only if there are at least N characters
            ajaxResultsContainer: null, // where to append results if mode is submit-keyword-ajax
            form: {
                action: null,
                parameterName: null,
                additionalParameters: null,
                accessToken: null
            }
        };

        this.options = {...defaultOptions, ...options};

        if (($(this.options.container).data('acceptedSuggestions') || {}).length > 0) {
            this.options.suggestionsAcceptedBeforeInit.push(...$(this.options.container).data('acceptedSuggestions'));
        }

        if (($(this.options.container).data('keywordPreset') || {}).length > 0) {
            this.options.preInput = $(this.options.container).data('keywordPreset');
        }

        this.guid = Space1.Util.newGuid().toSafeID();

        /* Search Object current state interface */
        this.state = {
            connected: false,
            input: '',
            acceptedSuggestions: [], // array of suggestions that have been accepted by user
            selectedSuggestionIndex: -1,
            availableSuggestions: [],
        };

        /* Search Object DOM elements */
        this.dom = {
            $container: null,
            $main: null,
            $acceptedSuggestionsContainer: null,
            $input: null,
            suggestionsTooltip: null,
            $suggestionsContainer: null,
            $suggestions: null,
            $buttonContainer: null,
            $button: null,
            $icon: null,
        };

        /* SignalR connection */
        this.connection = this.options.network.connection;

        try {
            this._buildDom();
            this._attachListeners();
            this._processAlreadyAcceptedSuggestions();

        } catch (error) {
            console.warn("Failed to initialize Space1.UI.Search", error);
        }
    }

    getTags() {
        return [...this.state.acceptedSuggestions,];
    }

    onUpdate() {
        if (Space1.Util.isFunction(this.options.onUpdateCallback)) {
            this.options.onUpdateCallback();
        }
    }

    _buildDom() {
        this.dom.$container = $(this.options.container);


        this.dom.$main = $('<aside>', {
            id: `${this.namespace}-${this.guid}`,
            class: `space1-search space1-search--${this.options.searchMode}`,
        });
        this.dom.$main.appendTo(this.dom.$container);

        // <input>
        this.dom.$input = $('<input>', {
            id: `${this.namespace}-input-${this.guid}`,
            type: 'search',
            placeholder: this.options.placeholder,
            incremental: true,
            class: 'space1-search__input search-query form-control',
            autocorrect: true,
            name: 'search',
            tabindex: 0,
            'aria-label': Space1.Strings.getKey('search/input/aria-label'),
        });
        this.dom.$input.appendTo(this.dom.$main);
        this.dom.$input.attr('autocomplete', 'off'); // autocomplete must be turned off only after node init
        if ((this.options.preInput || {}).length > 0) {
            this.setInputValue(this.options.preInput);
        }

        // <ul> accepted suggestions
        this.dom.$acceptedSuggestionsContainer = $('<ul>', {
            id: `${this.namespace}-accepted-suggestions-container-${this.guid}`,
            class: 'space1-search__accepted-suggestions-container',
        });
        this.dom.$acceptedSuggestionsContainer.appendTo(this.dom.$main);

        // show submit button only when necessary
        if (this.options.searchMode == 'create-missing-ajax' || this.options.searchMode == 'search-only' || this.options.searchMode == 'submit-keyword-ajax') {
            this.dom.$buttonContainer = $('<div>', {
                id: `${this.namespace}-submit_container-${this.guid}`,
                class: 'space1-search__button-container input-group-btn',
            });
            this.dom.$buttonContainer.appendTo(this.dom.$main);

            this.dom.$button = $('<button>', {
                id: `${this.namespace}-submit-${this.guid}`,
                class: 'space1-search__button btn btn-primary sp-button sp-button--transparent sp-button--squared',
                'aria-label': Space1.Strings.getKey('search/button/aria-label'),
                tabindex: 1,
            });
            this.dom.$button.appendTo(this.dom.$buttonContainer);

            this.dom.$icon = $('<span>', {
                class: `space1-search__icon ${this.options.searchIconClass}`
            });
            this.dom.$icon.appendTo(this.dom.$button);
        }

        // <ul> containing suggestions inside tooltip dropdown
        this.dom.$suggestionsContainer = $('<ul>', {
            id: `${this.namespace}-suggestions_container-${this.guid}`,
            class: 'space1-search__suggestions-container search-dropdown',
            role: 'listbox',
            'aria-label': Space1.Strings.getKey('search/dropdown/aria-label'),
        });

        // Tippy.js instance
        this.dom.suggestionsTooltip = tippy(this.dom.$input[0], {
            content: this.dom.$suggestionsContainer[0],
            animateFill: true,
            animation: 'fade',
            inertia: true,
            maxWidth: this.dom.$input.width(),
            theme: 'space1-search__tippy',
            aria: null,
            duration: [25, 25],
            distance: 0,
            flip: false,
            flipOnUpdate: false,
            interactive: true,
            trigger: 'manual',
            arrow: false,
            arrowType: 'round',
            placement: 'bottom-start',

            onShow(instance) {
                //
            },
            onHidden(instance) {
                //
            },
        });
    }

    _attachListeners() {
        let self = this;
        this.dom.$input.on('focus', this._onInputFocus.bind(self));
        this.dom.$input.on('input', this._onInputChange.bind(self));
        this.dom.$input.on('keydown', this._onKeyPress.bind(self));
        if (this.options.searchMode == 'search-only' || this.options.searchMode == 'submit-keyword-ajax' || this.options.searchMode == 'create-missing-ajax') {
            this.dom.$button.click(this.submit.bind(self));
        }
    }

    _connect() {
        if (this.connection == null) { // connection proxy needs to be created
            this.connection = new signalR.HubConnectionBuilder().withUrl(this.options.network.hub).build();
        }

        if ((this.connection || {}).connectionState == 0) { // if connection proxy is not connected
            // connect
            this.connection.start()
                .then(() => {
                    this.state.connected = true
                })
                .then(this._listenForSuggestions.bind(this))
                .catch(function (err) { // catch connection errors
                    return console.error(err.toString());
                });

        } else { // provided connection proxy is already connected
            this.state.connected = true;
            this._listenForSuggestions.bind(this);
        }
    }

    _listenForSuggestions() {
        console.log("Connected to suggestions hub.");

        this.connection.on(this.options.network.results, (result) => {
            if (result !== 'undefined') {
                let suggestions = JSON.parse(result);

                if (this.state.input == (suggestions || {}).SearchedText) {
                    this._renderSuggestions((suggestions || {}).Tags);
                } else {
                    console.log(`Searched: ${this.state.input} - Suggestions for: ${(suggestions || {}).SearchedText}`);
                    throw new Error("Received suggestions are outdated.");
                }

            } else {
                throw new Error("Received suggestions are invalid.");
            }
        });
    }

    _askForSuggestions() {
        if (this.state.connected) {
            this.connection.invoke(this.options.network.search, this.options.searchFor, this.state.input);
        }
    }

    _renderSuggestions(suggestions) {
        console.log("Received and ready to render suggestions.", suggestions);

        // remove from suggestions elements that user have already accepted
        if (this.state.acceptedSuggestions.length > 0) {
            this.state.availableSuggestions = suggestions.filter(
                (newSuggestion) => !this.state.acceptedSuggestions.find(acceptedSuggestion => acceptedSuggestion == newSuggestion));
        } else {
            this.state.availableSuggestions = suggestions;
        }

        this.dom.$suggestions = this.state.availableSuggestions.map(
            (suggestion, suggestionIndex) => {
                let $entry = $('<li>', {
                    tabindex: 1,
                    'aria-disabled': false,
                    'aria-selected': false,
                    'data-suggestion': suggestion,
                    role: 'option',
                    class: 'space1-search__suggestion sp-animation-ripple',
                    id: `${this.namespace}-suggestion-${Space1.Util.newGuid().toSafeID()}`,
                });

                $entry.html(this.constructor.boldifySubstring(suggestion.toLowerCase(), this.state.input));

                $entry.click((event) => {
                    Space1.UI.ripple($entry, event);
                    this.state.selectedSuggestionIndex = suggestionIndex;
                    this._hightlightSelectedSuggestion();
                    this._acceptSuggestion();
                    this.resetInput();
                });

                return $entry;
            }
        );

        if (this.dom.$suggestions.length > 0) {
            this.state.selectedSuggestionIndex = -1;
            let $firstSuggestion = this.dom.$suggestions[0];
            this.dom.$suggestionsContainer.attr('aria-activedescendant', $firstSuggestion[0].id);
            this._emptySuggestionsDropdown();
            this.dom.$suggestionsContainer.append(this.dom.$suggestions);
            this._showSuggestionsDropdown();
        } else {
            if (this.options.searchMode == 'create-missing') {
                this._showUserHint();
            } else {
                this._hideSuggestionsDropdown();
            }
        }
    }

    _showUserHint() {
        this._emptySuggestionsDropdown();
        let $hintUser = $('<li>', {
            'aria-disabled': true,
            'aria-selected': false,
            role: 'hint',
            class: 'space1-search__hint',
            id: `${this.namespace}-hint-${Space1.Util.newGuid().toSafeID()}`,
        });

        $hintUser.html(`${Space1.Strings.getKey('search/hint/write')}`);
        this.dom.$suggestionsContainer.append($hintUser);

        this._showSuggestionsDropdown(true);
    }

    _hideSuggestionsDropdown() {
        //console.log("Hide suggestions dropdown.");
        this.dom.suggestionsTooltip.hide();
    }

    _showSuggestionsDropdown(force = false) {
        if (this.dom.$input.is(":focus") || force) {
            //console.log("Show suggestions dropdown.");
            this.dom.suggestionsTooltip.set({maxWidth: this.dom.$input.width()});
            this.dom.suggestionsTooltip.show();
            return true;
        } else {
            return false;
        }
    }

    _emptySuggestionsDropdown() {
        //console.log("Empty suggestion dropdown.");
        this.dom.$suggestionsContainer.empty();
    }

    _hightlightSelectedSuggestion() {
        if (this.state.selectedSuggestionIndex > -1) {
            this.dom.$suggestionsContainer.find('.selected').removeClass('selected').attr('aria-selected', false);

            let $selected = this.dom.$suggestions[this.state.selectedSuggestionIndex];
            if ($selected && $selected.length) {
                $selected.addClass('selected');
                $selected.attr('aria-selected', true);
                this.dom.$suggestionsContainer.attr('aria-activedescendant', $selected[0].id);
            }
        }
    }

    _buildAcceptedSuggestionDomElement(suggestion, variant = '') {
        if (!this.options.disableCaseInsensitive) {
            suggestion = suggestion.toLowerCase();
        }

        let variantClass = variant.length ? `space1-search__accepted-suggestion--${variant}` : '';

        let $container = $('<li>', {
            'data-acceptedsuggestion': suggestion,
            'data-variant': variant,
            class: `space1-search__accepted-suggestion ${variantClass}`,
        }).append($('<span>').text(suggestion));

        // add hidden input element ready to be used in submit forms
        if (this.options.searchMode == 'create-missing') {
            $('<input>').attr({
                type: "hidden",
                name: this.options.form.parameterName,
                value: suggestion
            }).appendTo($container);
        }

        let $deleteButton = $('<button>', {
            class: 'space1-search__button-remove-suggestion',
        }).text('✕');

        $deleteButton.click((event) => {
            event.preventDefault();
            // remove from accepted
            //console.log("Remove suggestion from accepted list: " + suggestion);
            this._removeAcceptedSuggestion(suggestion);
        });

        $deleteButton.prependTo($container);

        return $container;
    }

    _processAlreadyAcceptedSuggestions() {
        if (this.options.searchMode == 'create-missing' || (this.options.suggestionsAcceptedBeforeInit || {}).length > 0) {
            this.options.suggestionsAcceptedBeforeInit.forEach(suggestion => this._acceptSuggestion(suggestion, false, true));
        }
    }

    _hightlightTagInPage(tagName) {
        $(`[data-tag-name="${tagName}"]`).addClass("space1-badge--active");
    }

    _removeTagHighlightInPage(tagName) {
        $(`[data-tag-name="${tagName}"]`).removeClass("space1-badge--active");
    }

    _acceptSuggestion(suggestion = null, createdByUser = false, createdBeforeInit = false) {
        let accepted = suggestion != null ? suggestion : this.state.availableSuggestions[this.state.selectedSuggestionIndex];

        if (accepted !== 'undefined' && accepted.length > 0) {
            // check if suggestion have already been accepted
            if (this.state.acceptedSuggestions.indexOf(accepted) >= 0) {
                //console.log("Suggestion was already been accepted.", accepted);
                this.resetInput();
                return;
            }

            accepted = Space1.Util.HtmlDecode(accepted);

            //console.log("Suggestion has been accepted.", accepted);
            this.state.acceptedSuggestions.push(accepted);
            this._hightlightTagInPage(accepted);

            let suggestionDomElementVariant = '';
            if (createdByUser) {
                suggestionDomElementVariant = 'new';
            }
            if (createdBeforeInit) {
                suggestionDomElementVariant = 'old';
            }
            let $acceptedSuggestionElement = this._buildAcceptedSuggestionDomElement(accepted, suggestionDomElementVariant);

            $acceptedSuggestionElement.hide();
            this.dom.$acceptedSuggestionsContainer.append($acceptedSuggestionElement.fadeIn());

            // refresh tippy position
            this.dom.suggestionsTooltip.set({placement: 'bottom-start'});

            if (this.state.availableSuggestions.length == 1) {
                //console.log("Last suggestion selected.");
                this.resetInput();
                this.state.selectedSuggestionIndex = -1;
            }

            this._renderSuggestions(this.state.availableSuggestions);
            this.onUpdate();
        }
    }

    _removeAcceptedSuggestion(suggestionToRemove) {
        let valuetoremove = suggestionToRemove;
        if (!this.options.disableCaseInsensitive) {
            valuetoremove = suggestionToRemove.toLowerCase();
        }
        let suggestionToRemoveIndex = this.state.acceptedSuggestions.indexOf(valuetoremove);

        this.state.acceptedSuggestions.splice(suggestionToRemoveIndex, 1);

        const _self = this;
        this.dom.$acceptedSuggestionsContainer.find(`[data-acceptedsuggestion='${suggestionToRemove}']`).fadeOut(150, function () {
            this.remove();
            _self.onUpdate();
        });

        this._removeTagHighlightInPage(suggestionToRemove);
    }

    submit(event = null) {
        if (Space1.Util.isFunction(this.options.beforeSearchCallback)) {
            this.options.beforeSearchCallback(this);
        }


        switch (this.options.searchMode) {
            case "search-only":
                this._onSearchResults();

                break;
            case "create-missing":
                // todo

                break;
            case "create-missing-ajax": {
                if (event) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }

                let submitDTO = {
                    parentId: this.options.form.additionalParameters['parentId'],
                    parentType: this.options.searchFor,
                    tags: this.state.acceptedSuggestions
                };

                let token = $('input[name="__RequestVerificationToken"]').val();
                let headers = {
                    RequestVerificationToken:
                    token
                };
                if(this.options.form.accessToken != null && typeof this.options.form.accessToken !== undefined && this.options.form.accessToken !== "") {
                    headers = {...headers, ...{
                        Authorization:
                            'Bearer ' + this.options.form.accessToken
                    }};
                }
                $.ajax({
                    url: this.options.form.action,
                    type: "post",
                    headers: headers,
                    data: submitDTO,
                    success: () => {
                        const oldClassList = this.dom.$icon[0].className.split(' ');
                        this.dom.$icon[0].className = '';
                        this.dom.$icon[0].classList.add('space1-search__icon', 'fas', 'fa-check', 'text-success');

                        setTimeout(() => {
                            this.dom.$icon[0].className = '';
                            this.dom.$icon[0].classList.add(...oldClassList);
                        }, 2000);

                        this._onSearchResults();
                    }
                });
            }
                break;
            case "submit-keyword-ajax": {
                if (event) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }

                let submitDTO = {};

                submitDTO["searchString"] = this.state.input;

                submitDTO[this.options.form.parameterName] = this.state.acceptedSuggestions;

                for (let param in this.options.form.additionalParameters) {
                    submitDTO[param] = this.options.form.additionalParameters[param];
                }

                let token = $('input[name="__RequestVerificationToken"]').val();
                let headers = {
                    RequestVerificationToken:
                    token
                };
                if(this.options.form.accessToken != null && typeof this.options.form.accessToken !== undefined && this.options.form.accessToken !== "") {
                    headers = {...headers, ...{
                            Authorization:
                                'Bearer ' + this.options.form.accessToken
                        }};
                }
                $.ajax({
                    url: this.options.form.action,
                    type: "post",
                    headers: headers,
                    data: submitDTO,
                    success: (resultsView) => {
                        let $resultsContainer = $(this.options.ajaxResultsContainer);
                        $resultsContainer.html(resultsView);

                        this._onSearchResults();
                    }
                });
            }
                break;
        }
    }

    _onSearchResults() {
        this._hightlightTagInPage();

        if (Space1.Util.isFunction(this.options.onSearchCallback)) {
            this.options.onSearchCallback(this);
        }
    }

    _onInputChange(event) {
        this.state.input = this.dom.$input.val();

        if (this.state.input.length > 2) {
            this._askForSuggestions();
        } else {
            this._hideSuggestionsDropdown();
        }
    }

    _onInputFocus(event) {
        if (!this.state.connected && !this.options.disableHub) {
            this._connect();
        }

        if (this.options.searchMode == 'create-missing' || this.options.searchMode == 'create-missing-ajax' && !(this.state.availableSuggestions || {}).length) {
            setTimeout(() => {
                if ((this.state.availableSuggestions || {}).length < 1) {
                    this._showUserHint();
                    this.dom.suggestionsTooltip.show();
                }

            }, 250)
        }
    }

    _onKeyPress(event) {
        switch (event.keyCode) {
            case 40: // down arrow
                this.state.selectedSuggestionIndex++;
                event.preventDefault();

                if (this.state.selectedSuggestionIndex >= this.dom.$suggestions.length) {
                    this.state.selectedSuggestionIndex = 0;
                }

                break;
            case 38: // up arrow
                this.state.selectedSuggestionIndex--;
                event.preventDefault();

                if (this.state.selectedSuggestionIndex < 0) {
                    this.state.selectedSuggestionIndex = this.dom.$suggestions.length;
                }

                break;
            case 13: // enter
                event.preventDefault();

                // if there are suggestions and there is one selected
                if (this.state.availableSuggestions.length > 0 && this.state.selectedSuggestionIndex > -1) {
                    this._acceptSuggestion();

                    // if we should create suggestions from user input
                } else if (this.options.searchMode == 'create-missing' || this.options.searchMode == 'create-missing-ajax') {
                    // and the user wrote something
                    if (this.state.input.length >= this.options.minimumInputLength) {
                        // check that new suggestion doesn't match with server suggestions
                        let createdByUser = false;
                        if (this.state.availableSuggestions.indexOf(this.state.input) < 0) {
                            // there isn't any match
                            createdByUser = true;
                        }
                        this._acceptSuggestion(this.state.input, createdByUser);
                        this.resetInput();
                    }
                } else {
                    this.submit();
                }

                break;

            case 8: // backspace
                /*
                if (this.state.input.length < 1 && this.state.acceptedSuggestions.length > 0) {
                    this._removeAcceptedSuggestion(this.state.acceptedSuggestions[this.state.acceptedSuggestions.length - 1]);
                }*/
                break;
            case 9: //tab
                if (this.dom.$input.is(':focus') && this.options.searchMode != 'create-missing' && this.options.searchMode != 'create-missing-ajax') {
                    event.preventDefault();
                    this.dom.$button.focus();
                }
                break;

            default: // do nothing
                return;
        }

        this._hightlightSelectedSuggestion();
    }

    setInputValue(value) {
        this.state.input = value;
        this.dom.$input.val(value);
    }

    resetInput() {
        //console.log("Reset input.");
        this.dom.$input.val('');
        this.state.input = '';

        return this;
    }

    /**
     * boldifySubstring - given two strings, searches the first string for occurencies of the second
     * @param {String} string - input string
     * @param {String} substring - what to search for
     * @returns {string} - returns string with bolded matches
     */
    static boldifySubstring(string, substring) {
        return string.replace(new RegExp(substring, 'gi'), '<b class="h-gradient-text--c1">' + substring + '</b>');
    }

    destroy() {
        if (this.state.connected) {
            this.connection.stop();
        }
        this.dom.$input.off();
        this.dom.$button.off();
        this.dom.$main.remove();
    }

};

Space1.Util.HtmlDecode = function (input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}

Space1.Util.TableToExcel = (function () {
    let uri = 'data:application/vnd.ms-excel;base64,'
        ,
        template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="utf-8"/><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
        , base64 = function (s) {
            return window.btoa(unescape(encodeURIComponent(s)))
        }
        , format = function (s, c) {
            return s.replace(/{(\w+)}/g, function (m, p) {
                return c[p];
            })
        };
    return function (table, name, filename) {
        if (!table.nodeType) table = document.getElementById(table);
        let ctx = {worksheet: name || 'Worksheet', table: table.innerHTML};

        let fakeDownloadLink = document.createElement('a');
        fakeDownloadLink.href = uri + base64(format(template, ctx));
        fakeDownloadLink.download = filename;
        fakeDownloadLink.click();
    }
})();

Space1.UI.vTabs = {
    initListeners: function () {
        let $vtab = $('.sp1-v-tabs');
        $vtab.each((index, vtab) => {
            let $vtab = $(vtab);
            let $tabsList = $vtab.find('.sp1-v-tabs__nav-list');
            let $tabs = $tabsList.find('.sp1-v-tabs__tab');

            $tabs.click(function () {
                Space1.UI.vTabs.openTab(this.id);
            });

            let historyId = $tabsList.data('history-id');
            if (historyId) {
                let previouslyOpenedId = JSON.parse(sessionStorage.getItem(historyId));
                if (previouslyOpenedId) {
                    Space1.UI.vTabs.openTab(previouslyOpenedId);
                }
            } else {
                Space1.UI.vTabs.openTab($tabs.first().attr("id"));
            }
        });


    },

    openTab: function (id) {
        const $tab = $("#" + id);
        let $tabsList = $tab.parents('.sp1-v-tabs__nav-list');

        let $alreadyOpenedTab = $tabsList.find('.sp1-v-tabs__tab--open');
        $alreadyOpenedTab.removeClass('sp1-v-tabs__tab--open');

        let tabContentId = '#' + $tab.data('content_id');
        let $tabContent = $(tabContentId);
        let $tabsContentList = $tabContent.parents('.sp1-v-tabs__contents');
        $tabsContentList.find('.sp1-v-tabs__tab-content--open').removeClass('sp1-v-tabs__tab-content--open');
        $tabContent.addClass('sp1-v-tabs__tab-content--open');
        $tab.addClass('sp1-v-tabs__tab--open');

        let historyId = $tabsList.data('history-id');
        if (historyId) {
            sessionStorage.setItem(historyId, JSON.stringify(id));
        }
    },
    initAnchorNavigation: function () {
        // With HTML5 history API, we can easily prevent scrolling!
        $('.sp1-v-tabs--save-history').each(function () {
            let $navbar = $(this).find('.sp1-v-tabs__nav-list');
            let historyId = $navbar.data('history-id');

            // set history on tab show
            $navbar.on('space1.show.vtab', function (e) {

                console.log(e.target);
            });
            /*
            // get history from sessionStorage
            let tabToOpen = sessionStorage.getItem(historyId);
            if (tabToOpen) {
                try {
                    console.log(JSON.parse(tabToOpen));
                    $(`a[href="${JSON.parse(tabToOpen)}"]`).tab('show');
                } catch (error) {
                }
            }
            */
        });
    }
};

Space1.UI.InitShowPassword = function () {
    $(".toggle-password").click(function () {

        $(this).toggleClass("glyphicon-eye-close");
        var input = $($(this).attr("toggle"));
        if (input.attr("type") == "password") {
            input.attr("type", "text");
        } else {
            input.attr("type", "password");
        }
    });
};

jQuery.fn.preventDoubleSubmission = function () {
    $(this).on('submit', function (e) {
        let $form = $(this);

        if ($form.data('submitted') === true) {
            // Previously submitted - don't submit again
            //alert('Form already submitted. Please wait.');
            e.preventDefault();
        } else {
            // Mark it so that the next submit can be ignored
            // ADDED requirement that form be valid
            if ($form.valid()) {
                $form.data('submitted', true);
            }
        }
    });

    // Keep chainability
    return this;
};

jQuery.fn.multiple_emails = function (options) {

    // Default options
    var defaults = {
        checkDupEmail: true,
        theme: "Bootstrap",
        position: "bottom"
    };

    // Merge send options with defaults
    var settings = $.extend({}, defaults, options);

    var deleteIconHTML = "";
    if (settings.theme.toLowerCase() == "Bootstrap".toLowerCase()) {
        deleteIconHTML = '<a href="#" class="multiple_emails-close" title="Remove"><span class="glyphicon glyphicon-remove"></span></a>';
    } else if (settings.theme.toLowerCase() == "SemanticUI".toLowerCase() || settings.theme.toLowerCase() == "Semantic-UI".toLowerCase() || settings.theme.toLowerCase() == "Semantic UI".toLowerCase()) {
        deleteIconHTML = '<a href="#" class="multiple_emails-close" title="Remove"><i class="remove icon"></i></a>';
    } else if (settings.theme.toLowerCase() == "Basic".toLowerCase()) {
        //Default which you should use if you don't use Bootstrap, SemanticUI, or other CSS frameworks
        deleteIconHTML = '<a href="#" class="multiple_emails-close" title="Remove"><i class="basicdeleteicon">Remove</i></a>';
    }

    return this.each(function () {
        //$orig refers to the input HTML node
        var $orig = $(this);
        var $list = $('<ul class="multiple_emails-ul" />'); // create html elements - list of email addresses as unordered list

        if ($(this).val() != '' && IsJsonString($(this).val())) {
            $.each(jQuery.parseJSON($(this).val()), function (index, val) {
                $list.append($('<li class="multiple_emails-email"><span class="email_name" data-email="' + val.toLowerCase() + '">' + val + '</span></li>')
                    .prepend($(deleteIconHTML)
                        .click(function (e) {
                            $(this).parent().remove();
                            refresh_emails();
                            e.preventDefault();
                        })
                    )
                );
            });
        }

        var $input = $('<input type="text" class="multiple_emails-input text-left" />').on('keyup', function (e) { // input
            $(this).removeClass('multiple_emails-error');
            var input_length = $(this).val().length;

            var keynum;
            if (window.event) { // IE					
                keynum = e.keyCode;
            } else if (e.which) { // Netscape/Firefox/Opera
                keynum = e.which;
            }

            // Supported key press is tab, enter, space or comma, there is no support for semi-colon since the keyCode differs in various browsers
            if (keynum == 9 || keynum == 32 || keynum == 188 || keynum == 13) {
                e.preventDefault();
                e.stopImmediatePropagation();
                display_email($(this), settings.checkDupEmail);
            } else if (keynum == 13) {
                e.preventDefault();
                e.stopImmediatePropagation();

                display_email($(this), settings.checkDupEmail);
            }

        }).on('blur', function (event) {
            if ($(this).val() != '') {
                display_email($(this), settings.checkDupEmail);
            }
        });

        var $container = $('<div class="multiple_emails-container" />').click(function () {
            $input.focus();
        }); // container div

        // insert elements into DOM
        if (settings.position.toLowerCase() === "top")
            $container.append($list).append($input).insertAfter($(this));
        else
            $container.append($input).append($list).insertBefore($(this));

        /*
        t is the text input device.
        Value of the input could be a long line of copy-pasted emails, not just a single email.
        As such, the string is tokenized, with each token validated individually.
    	
        If the dupEmailCheck variable is set to true, scans for duplicate emails, and invalidates input if found.
        Otherwise allows emails to have duplicated values if false.
        */
        function display_email(t, dupEmailCheck) {

            //Remove space, comma and semi-colon from beginning and end of string
            //Does not remove inside the string as the email will need to be tokenized using space, comma and semi-colon
            var arr = t.val().trim().replace(/^,|,$/g, '').replace(/^;|;$/g, '');
            //Remove the double quote
            arr = arr.replace(/"/g, "");
            //Split the string into an array, with the space, comma, and semi-colon as the separator
            arr = arr.split(/[\s,;]+/);

            var errorEmails = new Array(); //New array to contain the errors

            var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);

            for (var i = 0; i < arr.length; i++) {
                //Check if the email is already added, only if dupEmailCheck is set to true
                if (dupEmailCheck === true && $orig.val().indexOf(arr[i]) != -1) {
                    if (arr[i] && arr[i].length > 0) {
                        new function () {
                            var existingElement = $list.find('.email_name[data-email=' + arr[i].toLowerCase().replace('.', '\\.').replace('@', '\\@') + ']');
                            existingElement.css('font-weight', 'bold');
                            setTimeout(function () {
                                existingElement.css('font-weight', '');
                            }, 1500);
                        }(); // Use a IIFE function to create a new scope so existingElement won't be overriden
                    }
                } else if (pattern.test(arr[i]) == true) {
                    $list.append($('<li class="multiple_emails-email"><span class="email_name" data-email="' + arr[i].toLowerCase() + '">' + arr[i] + '</span></li>')
                        .prepend($(deleteIconHTML)
                            .click(function (e) {
                                $(this).parent().remove();
                                refresh_emails();
                                e.preventDefault();
                            })
                        )
                    );
                } else
                    errorEmails.push(arr[i]);
            }
            // If erroneous emails found, or if duplicate email found
            if (errorEmails.length > 0)
                t.val(errorEmails.join("; ")).addClass('multiple_emails-error');
            else
                t.val("");
            refresh_emails();
        }

        function refresh_emails() {
            var emails = new Array();
            var container = $orig.siblings('.multiple_emails-container');
            container.find('.multiple_emails-email span.email_name').each(function () {
                emails.push($(this).html());
            });
            $orig.val(JSON.stringify(emails)).trigger('change');
        }

        function IsJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }

        return $(this).hide();

    });

};


Space1.UI.Search.prototype.namespace = 'space1-search';

Space1.UI.setParentsHeight = function () {
    $('[data-inherit-parent-height]').each(function (i) {
        $(this).height($(this).parent('[data-parent-height]').height());
    });
}

Space1.UI.DateTimePicker = {
    currentLocale: null,
    setLocale: function (onLoaded) {
        if (this.currentLocale === null) {
            this.currentLocale = (navigator.language || navigator.browserLanguage).slice(0, 2);
            Space1.Util.LoadScript(`https://npmcdn.com/flatpickr/dist/l10n/${this.currentLocale}.js`).then(() => {
                console.log(`Loaded calendar localization file ${this.currentLocale}`);
                flatpickr.localize(flatpickr.l10ns[this.currentLocale]);
                onLoaded();
            });
        } else {
            onLoaded();
        }
    },
    newPicker: function (selector, modal) {
        this.setLocale(() => {
            document.querySelectorAll(selector).forEach(function (input) {
                const $input = $(input);
                if (!$input.attr('readonly') && !$input.attr('disabled')) {
                    const isDateTime = input.dataset.datetimeInput != undefined;
                    const isTimeOnly = input.dataset.datetimeInput == undefined;
                    const isDuration = input.name.toLowerCase().includes('duration');
                    const isUserLocale12hr = new Date().toLocaleTimeString().includes('PM') || new Date().toLocaleTimeString().includes('AM');

                    let pickerConfig = {};

                    if (isDuration) {
                        pickerConfig = {
                            noCalendar: true,
                            enableTime: true,
                            altInput: false,
                            static: true,
                            time_24hr: true,
                            defaultHour: '1',
                            parseDate: (datestr) => {
                                return moment(datestr, "HH:mm:ss.SSS", true).toDate();
                            },
                            formatDate: (date) => {
                                return moment(date).format('HH:mm');
                            }
                        };
                    } else if (isTimeOnly) {
                        pickerConfig = {
                            noCalendar: true,
                            enableTime: true,
                            altInput: true,
                            static: true,
                            time_24hr: !isUserLocale12hr,
                            parseDate: (datestr) => {
                                return moment(datestr, "HH:mm", true).toDate();
                            },
                            formatDate: (date, format, locale) => {
                                return moment(date).format('HH:mm');
                            },
                            onValueUpdate: (selectedDates, dateStr, instance) => {
                                $(instance.input).next('input').val(moment(dateStr).format('HH:mm'));
                            },
                            onReady: (selectedDates, dateStr, instance) => {
                                $(instance.input).next('input').val(moment(dateStr).format('HH:mm'));
                            }
                        };
                    } else if (isDateTime) {
                        pickerConfig = {
                            noCalendar: false,
                            enableTime: true,
                            altInput: true,
                            static: true,
                            time_24hr: !isUserLocale12hr,
                            // https://github.com/flatpickr/flatpickr/issues/1730
                            parseDate: (datestr) => {
                                return moment(datestr, "YYYY-MM-DDTHH:mm:ss.SSS", true).toDate();
                            },
                            formatDate: (date) => {
                                return moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS');
                            },
                            onValueUpdate: (selectedDates, dateStr, instance) => {
                                $(instance.input).next('input').val(moment(dateStr).format('llll'));
                            },
                            onReady: (selectedDates, dateStr, instance) => {
                                $(instance.input).next('input').val(moment(dateStr).format('llll'));
                            }
                        };
                    }

                    // https://github.com/flatpickr/flatpickr/issues/1730
                    pickerConfig.onOpen = function (selectedDates, dateStr, instance) {
                        if (modal)
                            modal.removeAttribute('tabindex');
                    };

                    pickerConfig.onClose = function () {
                        if (modal)
                            modal.removeAttribute('tabindex');
                    };

                    flatpickr(input, pickerConfig);
                }
            });
        });
    }
};

Space1.UI.sortList = function (target) {
    // (A) SET CSS + GET ALL LIST ITEMS
    target.classList.add("slist");
    let items = target.querySelectorAll("div .sortable-draggable-item"), current = null;

    // (B) MAKE ITEMS DRAGGABLE + SORTABLE
    for (let i of items) {
        // (B1) ATTACH DRAGGABLE
        i.draggable = true;

        // (B2) DRAG START - YELLOW HIGHLIGHT DROPZONES
        i.ondragstart = (ev) => {
            current = i;
            for (let it of items) {
                if (it != current) { it.classList.add("hint"); }
            }
        };

        // (B3) DRAG ENTER - RED HIGHLIGHT DROPZONE
        i.ondragenter = (ev) => {
            if (i != current) { i.classList.add("active"); }
        };

        // (B4) DRAG LEAVE - REMOVE RED HIGHLIGHT
        i.ondragleave = () => {
            i.classList.remove("active");
        };

        // (B5) DRAG END - REMOVE ALL HIGHLIGHTS
        i.ondragend = () => {
            for (let it of items) {
                it.classList.remove("hint");
                it.classList.remove("active");
            }
        };

        // (B6) DRAG OVER - PREVENT THE DEFAULT "DROP", SO WE CAN DO OUR OWN
        i.ondragover = (evt) => { evt.preventDefault(); };

        // (B7) ON DROP - DO SOMETHING
        i.ondrop = (evt) => {
            evt.preventDefault();
            if (i != current) {
                let currentpos = 0, droppedpos = 0;
                for (let it = 0; it < items.length; it++) {
                    if (current == items[it]) { currentpos = it; }
                    if (i == items[it]) { droppedpos = it; }
                }
                var dropElement = items[droppedpos];
                var currElement = items[currentpos];
                var dropParent = dropElement.parentNode;
                var dropSibling = dropElement.nextSibling === currElement ? dropElement : dropElement.nextSibling;
                currElement.parentNode.insertBefore(dropElement, currElement);
                dropParent.insertBefore(currElement, dropSibling);

                // Dispatch the event.
                const event = new CustomEvent('sortListOnDrop', { detail: { droppedPos: droppedpos, startPos: currentpos } });
                window.dispatchEvent(event);
            }
        };
    }
};

$(document).ready(function () {

    moment.locale(Space1.Strings.getNormalizedCurrentLanguageCode());

    AOS.init();

    globalLoadAnimation.stop();

    globalLoadAnimation.enableGlobalAjaxListener();

    globalLoadAnimation.enablePageReloadListener();

    Space1.UI.initTooltips();
    $(document).bind("ajaxSuccess", Space1.UI.initTooltips);

    $(".sp-animation-ripple").click(function (event) {
        rippleAnimateOnClick($(this), event);
    });

    expandCurrentMenuPage();

    Space1.UI.fullscreen.init();

    Space1.UI.Buttons.init();

    Space1.UI.assetBundleInfoTooltips.init();

    Space1.UI.partnerLicenseStatusTooltips.init();

    /*
    if (readCookie("sp-nightmode")) {
        Space1.UI.nightModeSwitch();
    }

    $('#space1-version').on('dblclick', Space1.UI.nightModeSwitch);
    */

    $('#space1-version').on('click', function () {
        window.location.href = Space1.Env.getWebRootPath() + "/ReleaseNotes/";
    });
    Space1.UI.vTabs.initListeners();

    Space1.UI.Tabs.initScrollableTabs();
    Space1.UI.Tabs.initAnchorNavigation();
    Space1.Util.tabState.initListener();
    Space1.UI.Colors.setGeneratedColors();
    Space1.UI.Colors.setGeneratedBackgroundColors();

    $(document).on('collapsed.pushMenu', Space1.UI.sidebar.inactiveHamburgerState);
    $(document).on('expanded.pushMenu', Space1.UI.sidebar.activeHamburgerState);

    $(".js-prevent-double-submit").preventDoubleSubmission();

    Space1.UI.autoScrollOnHover.newFactory('[data-autoscroll]');
    Space1.UI.colorPicker.newFactory('.sp-color-picker');

    Space1.UI.InitShowPassword();

    Space1.Util.formatDatetime.autoFormat();

    Space1.UI.setParentsHeight();

    $(window).on('resize', function () {
        Space1.UI.setParentsHeight();
    });


});
